webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularRoute = __webpack_require__(3);
	
	var _angularRoute2 = _interopRequireDefault(_angularRoute);
	
	var _angularSanitize = __webpack_require__(5);
	
	var _angularSanitize2 = _interopRequireDefault(_angularSanitize);
	
	var _angularShimsPlaceholder = __webpack_require__(7);
	
	var _angularShimsPlaceholder2 = _interopRequireDefault(_angularShimsPlaceholder);
	
	var _main = __webpack_require__(9);
	
	var _main2 = _interopRequireDefault(_main);
	
	var _parcels = __webpack_require__(13);
	
	var _parcels2 = _interopRequireDefault(_parcels);
	
	var _components = __webpack_require__(21);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _model = __webpack_require__(66);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _config = __webpack_require__(67);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _overlay = __webpack_require__(68);
	
	var _overlay2 = _interopRequireDefault(_overlay);
	
	var _route = __webpack_require__(69);
	
	var _route2 = _interopRequireDefault(_route);
	
	var _number = __webpack_require__(70);
	
	var _number2 = _interopRequireDefault(_number);
	
	var _notification = __webpack_require__(71);
	
	var _notification2 = _interopRequireDefault(_notification);
	
	var _parcelForce = __webpack_require__(72);
	
	var _parcelForce2 = _interopRequireDefault(_parcelForce);
	
	var _googleRecaptcha = __webpack_require__(73);
	
	var _googleRecaptcha2 = _interopRequireDefault(_googleRecaptcha);
	
	var _trackingCode = __webpack_require__(74);
	
	var _trackingCode2 = _interopRequireDefault(_trackingCode);
	
	var _eventType = __webpack_require__(75);
	
	var _eventType2 = _interopRequireDefault(_eventType);
	
	var _time = __webpack_require__(76);
	
	var _time2 = _interopRequireDefault(_time);
	
	var _statusCategory = __webpack_require__(77);
	
	var _statusCategory2 = _interopRequireDefault(_statusCategory);
	
	var _splitNumber = __webpack_require__(78);
	
	var _splitNumber2 = _interopRequireDefault(_splitNumber);
	
	var _array = __webpack_require__(79);
	
	var _array2 = _interopRequireDefault(_array);
	
	var _bootstrap = __webpack_require__(80);
	
	var _bootstrap2 = _interopRequireDefault(_bootstrap);
	
	__webpack_require__(83);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Import Utils.
	
	// Import Services (local).
	
	// Import Modules
	var MAIN = _angular2.default.module('app', [_angularRoute2.default, _parcels2.default, _components2.default, _angularSanitize2.default, _angularShimsPlaceholder2.default]).config(_main2.default).provider('configService', _config2.default).service('overlayService', _overlay2.default).service('routeService', _route2.default).service('numberService', _number2.default).service('notificationService', _notification2.default).service('parcelForceService', _parcelForce2.default).service('googleRecaptchaService', _googleRecaptcha2.default).service('trackingCodeService', _trackingCode2.default).service('eventTypeService', _eventType2.default).factory('applicationModel', _model2.default).filter('formatTime', _time2.default).filter('arrayToParagraph', _array2.default).filter('statusCategoryFilter', _statusCategory2.default).filter('splitNumberFilter', _splitNumber2.default).name;
	// Import global styles.
	exports.default = MAIN;
	
	
	(0, _bootstrap2.default)();

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mainView = __webpack_require__(10);
	
	var _mainView2 = _interopRequireDefault(_mainView);
	
	var _resultsView = __webpack_require__(11);
	
	var _resultsView2 = _interopRequireDefault(_resultsView);
	
	var _mainView3 = __webpack_require__(12);
	
	var _mainView4 = _interopRequireDefault(_mainView3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function routeConfig($routeProvider) {
	
	  $routeProvider.when('/', {
	    template: _mainView2.default,
	    controller: _mainView4.default,
	    controllerAs: 'vm'
	  }).when('/tracking-results/:number?', {
	    template: _resultsView2.default,
	    resolve: {
	      trackingResults: function trackingResults($route, routeService) {
	        return routeService.handleRequest($route);
	      }
	    }
	  }).when('/tracking-results/:number?/:mac?', {
	    template: _resultsView2.default,
	    resolve: {
	      trackingResults: function trackingResults($route, routeService) {
	        return routeService.handleNotification($route);
	      }
	    }
	  }).otherwise({
	    redirectTo: '/'
	  });
	}
	
	exports.default = routeConfig;

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"m-trackitem\">\n  <header class=\"row\">\n    <h2>{{ vm.header }}</h2>\n  </header>\n  <section class=\"row\">\n    <p class=\"hint\">\n      {{ vm.desc }}\n    </p>\n    <trackingcode></trackingcode>\n  </section>\n</div>"

/***/ }),
/* 11 */
/***/ (function(module, exports) {

	module.exports = "<trackingresults></trackingresults>"

/***/ }),
/* 12 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * @description: Sets the homepage text.
	 * @requires {Object} configService
	 */
	function mainViewController(configService, $window) {
	
	  var vm = this;
	
	  vm.header = configService.messages.tracking_code.header;
	  vm.desc = configService.messages.tracking_code.description;
	  $window.scrollTo(0, 0);
	}
	
	exports.default = mainViewController;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _baseClient = __webpack_require__(14);
	
	var _baseClient2 = _interopRequireDefault(_baseClient);
	
	var _tealium = __webpack_require__(15);
	
	var _tealium2 = _interopRequireDefault(_tealium);
	
	var _basesixtyfour = __webpack_require__(16);
	
	var _basesixtyfour2 = _interopRequireDefault(_basesixtyfour);
	
	var _tracking = __webpack_require__(17);
	
	var _tracking2 = _interopRequireDefault(_tracking);
	
	var _request = __webpack_require__(18);
	
	var _request2 = _interopRequireDefault(_request);
	
	var _parcels = __webpack_require__(19);
	
	var _parcels2 = _interopRequireDefault(_parcels);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* @ngInject */
	// Import shared services
	var parcelsModule = angular.module('parcelsModule', []).factory('baseClient', _baseClient2.default).factory('trackingService', _tracking2.default).factory('requestInterceptor', _request2.default).service('baseSixtyFour', _basesixtyfour2.default).service('tealiumService', _tealium2.default).service('parcelsService', _parcels2.default).config(['$httpProvider', function ($httpProvider) {
	
	  $httpProvider.interceptors.push('requestInterceptor');
	}]);
	// Import parcels shared services
	exports.default = parcelsModule.name;

/***/ }),
/* 14 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function baseClient($http) {
	
	  var baseUrl = '';
	
	  return {
	    /**
	     * @description Sets base url.
	     * @param {String} url.
	     */
	    setBaseUrl: function setBaseUrl(url) {
	
	      baseUrl = url;
	    },
	    /**
	     * @description Sends request.
	     * @param {Object} request
	     * @returns {Object}
	     */
	    sendRequest: function sendRequest(request) {
	
	      request.url = baseUrl.concat(request.uri);
	
	      return $http(request);
	    }
	
	  };
	}
	
	exports.default = baseClient;

/***/ }),
/* 15 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * @description : The Tealium Service.
	 * @requires {Object} $window: The Angular $window Service.
	 **/
	function tealiumService($window) {
	
	  // Tags which will persist throughout the application.
	  var baseTags = {};
	
	  return {
	
	    setBaseTags: function setBaseTags(tags) {
	
	      baseTags = tags;
	    },
	
	    getBaseTags: function getBaseTags() {
	      return baseTags;
	    },
	    /**
	     * @description Send expected Tealium tags.
	     * @param {Object} tags An object of Tealium tags to send.
	     * @param {String} type The type of tracking to be used.
	     * @return {Boolean} True if the Tealium tags have been set false instead.
	     */
	    sendTags: function sendTags(tags, type) {
	
	      if (!angular.isDefined($window.utag) || !angular.isDefined($window.utag.view)) {
	
	        return false;
	      }
	
	      if (type === 'link') {
	
	        return $window.utag.link(tags);
	      }
	
	      return $window.utag.view(angular.merge(baseTags, tags));
	    }
	
	  };
	}
	
	exports.default = tealiumService;

/***/ }),
/* 16 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* eslint-disable */
	
	function baseSixtyFour() {
	
	  /* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -  */
	  /*  Taken from http://www.movable-type.co.uk/scripts/base64.js */
	  /*  Base64 class: Base 64 encoding / decoding (c) Chris Veness 2002-2011                          */
	  /*  note: depends on Utf8 class
	  /*  http://www.movable-type.co.uk/scripts/base64.js */
	  /* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -  */
	
	  var base64Code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
	
	  /**
	   * Decode string from Base64, as defined by RFC 4648 [http://tools.ietf.org/html/rfc4648]
	   * (instance method extending String object). As per RFC 4648, newlines are not catered for.
	   *
	   * @param {String} str The string to be decoded from base-64
	   * @param {Boolean} [utf8decode=false] Flag to indicate whether str is Unicode string to be decoded
	   *   from UTF8 after conversion from base64
	   * @returns {String} decoded string
	   */
	  function _decode(str, utf8decode) {
	
	    utf8decode = typeof utf8decode == 'undefined' ? false : utf8decode;
	    var o1,
	        o2,
	        o3,
	        h1,
	        h2,
	        h3,
	        h4,
	        bits,
	        d = [],
	        plain,
	        coded;
	    var b64 = base64Code;
	
	    coded = utf8decode ? Utf8.decode(str) : str;
	
	    for (var c = 0; c < coded.length; c += 4) {
	      // unpack four hexets into three octets
	
	      h1 = b64.indexOf(coded.charAt(c));
	      h2 = b64.indexOf(coded.charAt(c + 1));
	      h3 = b64.indexOf(coded.charAt(c + 2));
	      h4 = b64.indexOf(coded.charAt(c + 3));
	
	      bits = h1 << 18 | h2 << 12 | h3 << 6 | h4;
	
	      o1 = bits >>> 16 & 0xff;
	      o2 = bits >>> 8 & 0xff;
	      o3 = bits & 0xff;
	
	      d[c / 4] = String.fromCharCode(o1, o2, o3);
	      // check for padding
	      if (h4 == 0x40) d[c / 4] = String.fromCharCode(o1, o2);
	      if (h3 == 0x40) d[c / 4] = String.fromCharCode(o1);
	    }
	
	    plain = d.join(''); // join() is far faster than repeated string concatenation in IE
	
	    return decodeURIComponent(escape(utf8decode ? Utf8.decode(plain) : plain));
	  }
	
	  /**
	   * Decode string from Base64URL, as defined by RFC 4648.
	   *
	   * @param {String} str The string to be decoded from base-64URL.
	   * @returns {String} decoded string.
	   */
	  function _urlDecode(str) {
	
	    str = _urlSpecialChar(str);
	
	    if (atob) {
	
	      try {
	
	        return atob(str);
	      } catch (e) {
	
	        return '';
	      }
	    }
	
	    return _decode(_addPadding(str));
	  }
	
	  /**
	   * Decode string from Base64URL into HEX, as defined by RFC 4648.
	   *
	   * @param {String} str The string to be decoded from base-64URL.
	   * @returns {String} decoded HEX string.
	   */
	  function _urlDecodeToHex(str) {
	
	    var raw = _urlDecode(str);
	    var hex = '';
	    var i = void 0;
	
	    for (i = 0; i < raw.length; i++) {
	
	      var _hex = raw.charCodeAt(i).toString(16);
	
	      hex += _hex.length === 2 ? _hex : '0' + _hex;
	    }
	
	    return hex;
	  }
	
	  /**
	   * Add necessary padding to string.
	   *
	   * @param {String} str The string to be padded.
	   * @returns {String} The string with padding.
	   */
	  function _addPadding(str) {
	
	    while (str.length % 4 !== 0) {
	
	      str = str + '=';
	    }
	
	    return str;
	  }
	
	  /**
	   * Special URL decode characters substitution for base64 decode.
	   *
	   * @param {String} str The string with URL friendly characters.
	   * @returns {String} The string to base64 decode.
	   */
	  function _urlSpecialChar(str) {
	
	    return str.replace('-', '+').replace('_', '/');
	  }
	
	  return {
	
	    decode: function decode(str) {
	      return _decode(str);
	    },
	    urlDecode: function urlDecode(str) {
	      return _urlDecode(str);
	    },
	    urlDecodeToHex: function urlDecodeToHex(str) {
	      return _urlDecodeToHex(str);
	    },
	    addPadding: function addPadding(str) {
	      return _addPadding(str);
	    },
	    urlSpecialChar: function urlSpecialChar(str) {
	      return _urlSpecialChar(str);
	    }
	
	  };
	}
	
	exports.default = baseSixtyFour;

/***/ }),
/* 17 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * @description : API request methods.
	 * @requires {Object} baseClient.
	 * @requires {Object} configService.
	 */
	function trackingService(baseClient, configService) {
	
	  baseClient.setBaseUrl(configService.api.base);
	
	  return {
	    /**
	     * @description : Gets list of items for specified user.
	     * @param {String} userId A user id.
	     * @param {String} siteId A site id.
	     * @param {Number} limit Number of results to retrieve.
	     * @returns {Object}
	     */
	    getHistory: function getHistory(userId, siteId) {
	      var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	
	
	      var request = {
	        method: 'GET',
	        uri: '/mailpieces/v2/user/' + userId + '/history/' + siteId
	      };
	
	      if (limit !== 0) {
	
	        request.params = { limit: limit };
	      }
	
	      return baseClient.sendRequest(request);
	    },
	    /**
	     * @description : Gets details of item.
	     * @param {String} trackingNumber
	     * @returns {Object}
	     */
	    getEvents: function getEvents(trackingNumber) {
	
	      var request = {
	        method: 'GET',
	        uri: '/mailpieces/v2/' + trackingNumber.toUpperCase() + '/events',
	        isWithCredentialRequired: true,
	        isgetRecaptchaHeadersRequired: true
	      };
	
	      return baseClient.sendRequest(request);
	    },
	    /**
	     * @description : Gets the signature tied to an item.
	     * @param {String} uri - uri of the signature.
	     * @param {Object} headers - headers needed for the call.
	     * @returns {Object}
	     */
	    getSignature: function getSignature(uri, headers) {
	
	      var request = {
	        method: 'GET',
	        uri: uri,
	        isWithCredentialRequired: true,
	        headers: headers,
	        responseType: 'blob'
	      };
	
	      return baseClient.sendRequest(request);
	    },
	    /**
	     * @description : Gets summary of items.
	     * @param {Number} jwtMailPieces Number of results to retrieve.
	     * @param {Number} limit Number of results to retrieve.
	     * @returns {Object}
	     */
	    getSummary: function getSummary(jwtMailPieces) {
	
	      var request = {
	        method: 'GET',
	        uri: '/mailpieces/v2/summary',
	        params: { mailPieceId: jwtMailPieces }
	      };
	
	      return baseClient.sendRequest(request);
	    },
	    /**
	     * @description : Sends a Delete Request to server.
	     * @param {Array} mailPieceId singular or multi Tracking Numbers.
	     * @param {Number}  userId value of the guid.
	     * @param {String} siteId value from Config service.
	     * @returns {Object}
	     */
	    deleteCards: function deleteCards(mailPieceId, userId, siteId) {
	
	      var request = {
	        method: 'DELETE',
	        uri: '/mailpieces/v2/user/' + userId + '/history/' + siteId,
	        params: { mailPieceId: mailPieceId }
	      };
	
	      return baseClient.sendRequest(request);
	    }
	
	  };
	}
	
	exports.default = trackingService;

/***/ }),
/* 18 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * @description : Intercepts every request and appends required headers.
	 * @requires {Object} configService
	 * @requires {Object} applicationModel
	 * @requires {Promise} $q
	 * @requires {Object} $cookies
	 * @requires {Object} $rootScope
	 * @requires {Object} $timeout
	 **/
	function requestInterceptor(configService, applicationModel, $q, $cookies, $rootScope, $timeout) {
	
	  var ERROR_MESSAGE = configService.messages.system_error.tracking_unavailable;
	
	  /**
	   * @description: Re-submit number depending on error code.
	   * @param {Object} response
	   */
	  function checkErrorResubmit(response) {
	
	    var errorCodeResubmit = 'E0015';
	
	    if (angular.isDefined(response.data.errors[0].errorCode)) {
	
	      if (response.data.errors[0].errorCode === errorCodeResubmit) {
	
	        $timeout(function () {
	
	          if (applicationModel && applicationModel.googleRecaptcha) {
	
	            // Clear sessionToken for next request.
	            applicationModel.googleRecaptcha.sessionToken = null;
	            $rootScope.$emit('externalReSubmit', applicationModel.sanitizedNumber);
	          }
	        }, 100);
	      }
	    }
	  }
	
	  return {
	
	    request: function request(_request) {
	
	      /**
	       * @description : Add specific headers for when a reCAPTCHA system is
	       * used.
	       **/
	      function addRecaptchaHeaders() {
	
	        if (applicationModel.googleRecaptcha.sessionToken) {
	
	          // TODO: Remove deprecated "X-Recaptcha-Session" once APIm 3.2 is deployed.
	          _request.headers['X-Recaptcha-Session'] = applicationModel.googleRecaptcha.sessionToken;
	          _request.headers['X-RMG-API-Session'] = applicationModel.googleRecaptcha.sessionToken;
	        } else if (applicationModel.googleRecaptcha.googleToken) {
	
	          // TODO: Remove deprecated "X-Recaptcha-Response" header once APIm 3.2 is deployed.
	          _request.headers['X-Recaptcha-Response'] = applicationModel.googleRecaptcha.googleToken;
	          _request.headers['X-RMG-Recaptcha'] = applicationModel.googleRecaptcha.googleToken;
	          // We want to get rid of googleToken as we assume it would be used and invalidated.
	          delete applicationModel.googleRecaptcha.googleToken;
	        }
	      }
	
	      _request.headers['X-IBM-Client-ID'] = configService.api.ibm_client_id;
	      _request.headers['Accept-Language'] = document.documentElement.lang;
	      _request.headers['X-RMG-Language'] = document.documentElement.lang === 'en' ? 'en_GB' : 'cy_CY';
	
	      if (applicationModel.authToken) {
	
	        _request.headers['X-RMG-Auth-Token'] = 'Bearer ' + $cookies.get('parcels_jwt');
	      }
	
	      if (angular.isDefined(_request.isWithCredentialRequired) && _request.isWithCredentialRequired) {
	
	        // withCredentials is often required when we need to receive set/send
	        // a cookie.
	        _request.withCredentials = true;
	      }
	
	      if (applicationModel.macSessionHeader) {
	
	        _request.headers['X-RMG-MAC'] = applicationModel.macSessionHeader;
	
	        // Reset applicationModel MAC once added to the Header.
	        applicationModel.macSessionHeader = false;
	      } else if (angular.isDefined(_request.isgetRecaptchaHeadersRequired) && _request.isgetRecaptchaHeadersRequired) {
	
	        addRecaptchaHeaders();
	      }
	
	      _request.timeout = configService.api.script_timeout;
	      return _request;
	    },
	
	    response: function response(_response) {
	
	      // TODO: Remove deprecated "X-Recaptcha-Session" once APIm 3.2 is deployed.
	      var recaptchaSession = _response.headers('X-RMG-API-Session') || _response.headers('x-recaptcha-session');
	
	      // Set the cookie as session cookie as we check if is valid later in the code.
	      if (recaptchaSession !== undefined && recaptchaSession !== null) {
	
	        // TODO: Remove deprecated "X-Recaptcha-Session" once APIm 3.2 is deployed.
	        $cookies.put('x-recaptcha-session', recaptchaSession, { secure: true, path: '/' });
	        $cookies.put('X-RMG-API-Session', recaptchaSession, { secure: true, path: '/' });
	        applicationModel.googleRecaptcha.sessionToken = recaptchaSession;
	      }
	
	      // Quick sanity check to see if we have any data
	      if (Object.keys(_response).length === 0) {
	
	        return $q.reject(ERROR_MESSAGE);
	      }
	
	      // If response contains an error or errors, reject the promise.
	      if (angular.isDefined(_response.data) && (angular.isDefined(_response.data.error) || angular.isDefined(_response.data.errors))) {
	
	        var error = _response.data.error || _response.data.errors;
	        error.status = _response.status;
	
	        checkErrorResubmit(_response);
	
	        return $q.reject(error);
	      } else if (angular.isDefined(_response.data) && _response.data === '') {
	
	        return $q.reject(ERROR_MESSAGE);
	      }
	
	      return _response;
	    },
	
	    responseError: function responseError(rejection) {
	
	      var error = ERROR_MESSAGE;
	      var contentType = rejection.headers('content-type');
	
	      // Backend is not responding accordingly or there is a network issue
	      if (rejection.status === -1 || !contentType) {
	
	        rejection.error = error;
	        return $q.reject(rejection);
	      }
	
	      if (angular.isDefined(rejection.data) && typeof rejection.data !== 'string' && contentType.indexOf('application/json') === 0) {
	
	        if (angular.isDefined(rejection.data.error)) {
	
	          error = rejection.data.error;
	        }
	
	        // A getEvents() error object or technical errors.
	        if (angular.isDefined(rejection.data.errors)) {
	
	          error = rejection.data.errors;
	
	          checkErrorResubmit(rejection);
	        }
	
	        if (typeof error !== 'string') error.status = rejection.status;
	      }
	
	      // Set error to rejection response.
	      rejection.error = error;
	
	      return $q.reject(rejection);
	    }
	
	  };
	}
	
	exports.default = requestInterceptor;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _snarkdown = __webpack_require__(20);
	
	var _snarkdown2 = _interopRequireDefault(_snarkdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @description : Common methods for parcels.
	 * @requires {Object} baseSixtyFour Polyfill to decode b64 strings.
	 * @requires {Object} trackingService.
	 * @requires {Object} $cookies
	 */
	function parcelsService(baseSixtyFour, trackingService, $cookies) {
	
	  var mailPieceListIdsOrdered = {};
	
	  /**
	   * @description : Check if an object has a property, then return the object
	   * property if yes, an empty string otherwise.
	   * @param {Object} obj An object.
	   * @param {String} prop A property.
	   * @returns {Object|String} An object property or an empty string.
	   */
	  var isSet = function isSet(obj, prop) {
	
	    if (angular.isObject(obj) && Object.prototype.hasOwnProperty.call(obj, prop)) return obj[prop];
	
	    return '';
	  };
	
	  /**
	   * @description : Ordering of the mailpieces by timestamp.
	   * @param {Object} mailPieceList - mailpiece object.
	   */
	  var orderMailPieces = function orderMailPieces(mailPieceList) {
	
	    // eslint-disable-next-line
	    for (var a in mailPieceListIdsOrdered) {
	      delete mailPieceListIdsOrdered[a];
	    } // Sorting param array by timestamp last accessed.
	    var sortedMailPieceList = mailPieceList.sort(function (prev, next) {
	      return next.lastAccessedTimestamp - prev.lastAccessedTimestamp;
	    });
	
	    var i = 0;
	    for (i; i < sortedMailPieceList.length; i++) {
	
	      mailPieceListIdsOrdered[i] = mailPieceList[i].mailPieceId;
	    }
	  };
	
	  /**
	   * @description : Call getHistory endpoint.
	   * @param {String} guid A user global id.
	   * @param {String} appId An application id.
	   * @param {Number} limit The number of results we want to display.
	   * @returns {Object} An object of ordered mailPieces Ids.
	   */
	  var getHistory = function getHistory(guid, appId, limit) {
	    return trackingService.getHistory(guid, appId, limit).then(function (getHistoryResponse) {
	
	      if (isSet(getHistoryResponse, 'data')) {
	
	        if (isSet(getHistoryResponse.data, 'mpDetails')) {
	
	          orderMailPieces(getHistoryResponse.data.mpDetails);
	          return getHistoryResponse.data.jwt;
	        }
	      }
	
	      return Promise.reject(getHistoryResponse);
	    });
	  };
	
	  /**
	   * @description : Call getSummary endpoint.
	   * @param {Object} getHistoryResponse The getHistory response object.
	   * @returns {Object} An object of mailPieces Ids.
	   */
	  var getSummary = function getSummary(getHistoryResponse) {
	    return trackingService.getSummary(getHistoryResponse).then(function (getSummaryResponse) {
	
	      var sortedData = {
	        mailPieces: []
	      };
	
	      var i = 0;
	      var j = 0;
	
	      // Loop through the list of ordered mailPieces and get the corresponding
	      // entry in the getSummary response. Then recreate an object of ordered
	      // mailPieces to return.
	      angular.forEach(mailPieceListIdsOrdered, function (sortedMailPiecesIdValue) {
	
	        i = 0;
	        for (i; i < getSummaryResponse.data.mailPieces.length; i++) {
	
	          if (sortedMailPiecesIdValue === getSummaryResponse.data.mailPieces[i].mailPieceId) {
	
	            sortedData.mailPieces[j] = getSummaryResponse.data.mailPieces[i];
	          }
	        }
	
	        j++;
	      });
	
	      getSummaryResponse.data = sortedData;
	
	      return getSummaryResponse;
	    });
	  };
	
	  /**
	   * @description : Call getHistory then use the result to call getSummary then
	   * return the getSummary response as a Promise.
	   * @param {Number} guid A user global id.
	   * @param {Number} appId An application id.
	   * @param {Number} limit The number of results we want to display.
	   * @returns {Promise} a getSummary promise.
	   */
	  var getRtiResults = function getRtiResults(guid, appId) {
	    var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	    return getHistory(guid, appId, limit).then(function (getHistoryResponse) {
	      return getSummary(getHistoryResponse).then(function (getSummaryResponse) {
	        return getSummaryResponse;
	      });
	    });
	  };
	
	  /**
	   * @description : Decode a JWT token.
	   * @param {String} token A token to decode.
	   * @returns {String|Boolean} The decoded token or false.
	   */
	  var decodeJWT = function decodeJWT(token) {
	
	    if (token && token !== null && token !== undefined) {
	
	      var base64Url = token.split('.')[1];
	
	      if (base64Url !== null && base64Url !== undefined) {
	
	        return JSON.parse(baseSixtyFour.urlDecode(base64Url));
	      }
	
	      return false;
	    }
	
	    return false;
	  };
	
	  /**
	   * @description : Checks if object exists on the list and compares if is equal.
	   * @param {Object} objList The object list to iterate.
	   * @param {Object} obj The object we want to check.
	   * @returns {Boolean}
	   */
	  var contains = function contains(objList, obj) {
	
	    var i = objList.length;
	    while (i--) {
	
	      if (JSON.stringify(objList[i]) === JSON.stringify(obj)) {
	
	        return true;
	      }
	    }
	
	    return false;
	  };
	
	  /**
	   * @description: Check for matches in the nested members.
	   * @param {Object} obj : the object being evaluated.
	   * @param {String} args : comma separated values of 1 or more levels deep into the object.
	   * @returns  {Boolean}
	   */
	  var checkNested = function checkNested(obj) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var nestedObj = obj;
	
	    for (var i = 0; i < args.length; i += 1) {
	
	      if (!nestedObj || !Object.prototype.hasOwnProperty.call(nestedObj, args[i])) {
	
	        return false;
	      }
	
	      nestedObj = nestedObj[args[i]];
	    }
	
	    return true;
	  };
	
	  /**
	   * @description : Formats a date object to 'dd/mm/yyyy', splits it and returns
	   * the date and time objects.
	   * @param {Object} date A date object.
	   * @returns {Object} {date, time}.
	   */
	  var formatDate = function formatDate(date) {
	
	    var isoDate = date.toISOString().substr(0, 10).split('-').reverse().join('/');
	
	    var timeSplit = date.toString().split(/:(.+)/)[1];
	
	    return {
	      date: isoDate,
	      time: timeSplit.split(' ')[0]
	    };
	  };
	
	  /**
	   * @description: Checks the validation for a JWT token.
	   * @param   {String} jwtToken : The encoded JWT we want to check.
	   * @returns {Boolean} : If the token is valid.
	   */
	  var isValidSessionJWT = function isValidSessionJWT(jwtToken) {
	
	    // Transform the Date().getTime() from milliseconds to seconds.
	    var now = Math.floor(new Date().getTime() / 1000);
	    var JWT = jwtToken ? decodeJWT(jwtToken) : '';
	    var exp = isSet(JWT, 'exp') !== '' ? isSet(JWT, 'exp') : 0;
	
	    return JWT && parseInt(exp, 10) && exp > now;
	  };
	
	  /**
	   * @description: Sets the state for Logged In cookie.
	   * @returns {Boolean} : If the LoggedIn cookie is set and valid.
	   */
	  var isValidCookie = function isValidCookie() {
	
	    var cookie = $cookies.get('parcels_jwt');
	
	    if (cookie) {
	
	      return isValidSessionJWT(cookie);
	    }
	
	    return false;
	  };
	
	  /**
	   * @description: Converts Markdown to HTML.
	   * @param {Object|String} mdObject : The the markdown object being translated.
	   * @returns {String} : An HTML string.
	   */
	  var markdownToHTML = function markdownToHTML() {
	    var mdObject = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	
	    var html = (0, _snarkdown2.default)(mdObject);
	    return html;
	  };
	
	  /**
	   * @description: Remove the timezone from the original date.
	   * @param {String} dateString A date in ISO 8601 format provided by the API as "2016-11-20T10:04:00+01:00".
	   * @returns {string|*} date.
	   */
	  function ignoreTimezone(dateString) {
	
	    return dateString.substr(0, 19);
	  }
	
	  return {
	    getHistory: getHistory,
	    orderMailPieces: orderMailPieces,
	    getSummary: getSummary,
	    getRtiResults: getRtiResults,
	    decodeJWT: decodeJWT,
	    isSet: isSet,
	    contains: contains,
	    checkNested: checkNested,
	    formatDate: formatDate,
	    isValidCookie: isValidCookie,
	    isValidSessionJWT: isValidSessionJWT,
	    markdownToHTML: markdownToHTML,
	    ignoreTimezone: ignoreTimezone
	  };
	}
	
	exports.default = parcelsService;

/***/ }),
/* 20 */,
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularCookies = __webpack_require__(22);
	
	var _angularCookies2 = _interopRequireDefault(_angularCookies);
	
	var _trackingCode = __webpack_require__(24);
	
	var _trackingCode2 = _interopRequireDefault(_trackingCode);
	
	var _trackingResults = __webpack_require__(31);
	
	var _trackingResults2 = _interopRequireDefault(_trackingResults);
	
	var _overlayTemplate = __webpack_require__(43);
	
	var _overlayTemplate2 = _interopRequireDefault(_overlayTemplate);
	
	var _recentlyTracked = __webpack_require__(48);
	
	var _recentlyTracked2 = _interopRequireDefault(_recentlyTracked);
	
	var _googleRecaptcha = __webpack_require__(53);
	
	var _googleRecaptcha2 = _interopRequireDefault(_googleRecaptcha);
	
	var _pfwOverlay = __webpack_require__(56);
	
	var _pfwOverlay2 = _interopRequireDefault(_pfwOverlay);
	
	var _gpsMap = __webpack_require__(61);
	
	var _gpsMap2 = _interopRequireDefault(_gpsMap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var componentsModule = _angular2.default.module('app.components', [_angularCookies2.default]).component('trackingcode', _trackingCode2.default).component('overlay', _overlayTemplate2.default).component('pfwOverlay', _pfwOverlay2.default).component('trackingresults', _trackingResults2.default).component('recentlytracked', _recentlyTracked2.default).component('googlerecaptcha', _googleRecaptcha2.default).component('gpsMapComponent', _gpsMap2.default).name;
	
	// Load components.
	exports.default = componentsModule;

/***/ }),
/* 22 */,
/* 23 */,
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _trackingCode = __webpack_require__(25);
	
	var _trackingCode2 = _interopRequireDefault(_trackingCode);
	
	var _trackingCodeView = __webpack_require__(26);
	
	var _trackingCodeView2 = _interopRequireDefault(_trackingCodeView);
	
	__webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var trackingCodeComponent = {
	  template: _trackingCodeView2.default,
	  controller: _trackingCode2.default,
	  controllerAs: 'vm'
	};
	
	exports.default = trackingCodeComponent;

/***/ }),
/* 25 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * @description : fetch, parse and validate tracking codes
	 * @requires {Object} applicationModel
	 * @requires {Object} configService
	 * @requires {Object} googleRecaptchaService
	 * @requires {Object} numberService
	 * @requires {Object} parcelForceService
	 * @requires {Object} overlayService
	 * @requires {Object} parcelsService
	 * @requires {Object} tealiumService : provides methods to work with tealium object tags.
	 * @requires {Object} trackingCodeService
	 * @requires {Object} trackingService
	 * @requires {Object} $location
	 * @requires {Object} $cookies
	 * @requires {Object} $rootScope
	 * @requires {Object} $scope
	 * @requires {Function} $timeout
	 * @requires {Object} $window
	 */
	function trackingCodeController(applicationModel, configService, googleRecaptchaService, numberService, parcelForceService, overlayService, parcelsService, tealiumService, trackingCodeService, trackingService, $location, $cookies, $rootScope, $scope, $timeout, $window) {
	  var _this = this;
	
	  var vm = this;
	  var inputElem = document.getElementById('track-item');
	  var sanitizedTrackingNumber = void 0;
	  var errTags = void 0;
	
	  // Set tealiumService.
	  var persistentTags = {
	
	    pageApplicationName: configService.tealium.app_name,
	    pagePersona: configService.tealium.instance.toLowerCase(),
	    pageLanguage: document.documentElement.lang === 'en' ? 'en-gb' : document.documentElement.lang
	
	  };
	
	  // Pollyfill for remove().
	  if (!('remove' in Element.prototype)) {
	
	    Element.prototype.remove = function () {
	
	      if (_this.parentNode) {
	
	        _this.parentNode.removeChild(_this);
	      }
	    };
	  }
	
	  tealiumService.setBaseTags(persistentTags);
	
	  if (document.getElementById('flmnt-placeholder')) {
	
	    var childPlaceholder = document.getElementById('flmnt-placeholder');
	    childPlaceholder.parentNode.removeChild(childPlaceholder);
	  }
	
	  if (document.getElementById('flmntChatbot')) {
	
	    var child = document.getElementById('flmntChatbot');
	    child.parentNode.removeChild(child);
	  }
	
	  if (document.getElementById('flmntWidgetInit')) {
	
	    var childWidget = document.getElementById('flmntWidgetInit');
	    childWidget.parentNode.removeChild(childWidget);
	  }
	
	  /**
	   * @description : generates tealium tags for this page.
	   * @param {Boolean} isLoggedIn
	   * @param {Object} error
	   * @returns {Object}
	   */
	  function searchPage(isLoggedIn, error) {
	
	    var errorObj = angular.isObject(error) ? error : {};
	    var cookie = $cookies.get('parcels_jwt');
	    var JWT = parcelsService.decodeJWT(cookie);
	    var errorType = parcelsService.isSet(errorObj, 'status') ? 'System Error' : 'Field Validation';
	    var breadCrumb = parcelsService.isSet(configService, 'breadcrumbs') ? JSON.parse(configService.breadcrumbs) : '';
	
	    var tags = {
	      pageName: configService.tealium.site_prefix + ' >' + configService.tealium.instance + ' >Track Your Items >Search',
	      pageMenuTree: configService.tealium.instance + '|Track Your Items|Search',
	      pageApplicationStep: 'Search',
	      pageTemplate: 'Search Form',
	      pageBreadCrumb: Array.isArray(breadCrumb) && breadCrumb.length > 1 ? breadCrumb.join('|') : breadCrumb.toString()
	    };
	
	    var userTags = {
	      visitorGUID: parcelsService.isSet(JWT, 'sub'),
	      visitorEmail: parcelsService.isSet(JWT, 'email'),
	      visitorSegment: parcelsService.isSet(JWT, 'visitorSegment'),
	      visitorRMPPost: parcelsService.isSet(JWT, 'visitorRMPPost'),
	      visitorRMPPhone: parcelsService.isSet(JWT, 'visitorRMPPhone'),
	      visitorRMPEmail: parcelsService.isSet(JWT, 'visitorRMPEmail'),
	      visitorRMPOther: parcelsService.isSet(JWT, 'visitorRMPOther')
	    };
	
	    var errorTags = {
	      pageName: configService.tealium.site_prefix + ' >' + configService.tealium.instance + ' >Track Your Items >Search Error',
	      pageMenuTree: configService.tealium.instance + '|Track Your Items|Search Error',
	      pageErrorType: errorType,
	      pageErrorMessage: errorType + ':' + (parcelsService.isSet(errorObj, 'status') ? errorObj.status : 0) + ':' + (Object.keys(errorObj).length > 0 && error ? parcelsService.isSet(errorObj[0], 'errorCode') : 0),
	      pageApplicationStep: 'Search Error',
	      pageTemplate: 'Search Form',
	      pageBreadCrumb: Array.isArray(breadCrumb) && breadCrumb.length > 1 ? breadCrumb.join('|') : breadCrumb.toString()
	    };
	
	    if (isLoggedIn) {
	
	      if (Object.keys(errorObj).length === 0 && error === undefined) return angular.merge(tags, userTags);
	      if (Object.keys(errorObj).length > 0 || error !== undefined) return angular.merge(errorTags, userTags);
	    }
	
	    if (!isLoggedIn) {
	
	      if (Object.keys(errorObj).length > 0 || error !== undefined) return errorTags;
	    }
	
	    return tags;
	  }
	
	  function resetErrors() {
	
	    vm.showError = false;
	    vm.errorMessages = [];
	    applicationModel.urlRequest = {};
	  }
	
	  function displayErrors(errorMessages) {
	
	    var errorCode = void 0;
	    resetErrors();
	
	    if (Array.isArray(errorMessages)) {
	
	      vm.errorMessages = errorMessages;
	      errorCode = parcelsService.isSet(vm.errorMessages[0], 'errorCode');
	    } else if (typeof errorMessages === 'string' || errorMessages instanceof String) {
	
	      vm.errorMessages.push(errorMessages);
	    } else if (angular.isDefined(errorMessages.data)) {
	
	      if (angular.isDefined(errorMessages.data.errors)) {
	
	        vm.errorMessages.push(errorMessages.data.errors[0]);
	        errorCode = parcelsService.isSet(errorMessages.data.errors[0], 'errorCode');
	      }
	    } else if (angular.isDefined(errorMessages.errors)) {
	
	      vm.errorMessages.push(errorMessages.errors);
	      errorCode = parcelsService.isSet(errorMessages.errors[0], 'errorCode');
	    } else if (angular.isDefined(errorMessages.error)) {
	
	      vm.errorMessages.push(errorMessages.error[0]);
	      errorCode = parcelsService.isSet(errorMessages.error[0], 'errorCode');
	    } else {
	
	      vm.errorMessages.push(errorMessages.errorDescription);
	    }
	
	    // Not displaying 401 Unauthorised response errors.
	    vm.showError = errorCode !== 'E0015';
	
	    // Set tealium error object.
	    errTags = searchPage(vm.isLoggedIn, errorMessages);
	    tealiumService.sendTags(errTags);
	  }
	
	  function displayResults(response) {
	
	    // TODO Remove deprecated Header once APIm 3.2 is deployed.
	    if (response.headers('x-recaptcha-session')) {
	
	      applicationModel.googleRecaptcha.sessionToken = response.headers('x-recaptcha-session');
	    }
	
	    // Set the session token for any response. Also error responses.
	    if (response.headers('X-RMG-API-Session')) {
	
	      applicationModel.googleRecaptcha.sessionToken = response.headers('X-RMG-API-Session');
	    }
	
	    if (parcelsService.checkNested(response, 'data', 'errors')) {
	
	      displayErrors(response.data.errors);
	    } else {
	
	      applicationModel.trackingDetails = response.data;
	      applicationModel.estimatedDelivery = response.data.mailPieces.estimatedDelivery;
	      $location.path('/tracking-results/' + response.data.mailPieces.mailPieceId);
	    }
	  }
	
	  function processRequest(trackingNumber) {
	
	    trackingService.getEvents(trackingNumber).then(displayResults, displayErrors);
	  }
	
	  /**
	   * @description : Handle tracking number from the URL address on page load.
	   * If there are errors set on the application model display those.
	   */
	  function checkURLRequest() {
	
	    if (applicationModel.urlRequest.number) {
	
	      vm.trackId = numberService.filterNumber(applicationModel.urlRequest.number);
	    }
	
	    if (applicationModel.urlRequest.error) {
	
	      displayErrors(applicationModel.urlRequest.error);
	    }
	  }
	
	  /**
	   * @description : Toggles PFW overlay with/out the tracking number.
	   * @param {String} trackingNumber
	   */
	  function togglePfwOverlay(trackingNumber) {
	
	    overlayService.setPfwTrackingNumber(trackingNumber);
	    overlayService.togglePfwOverlay();
	    vm.pfwOverlayStatus = overlayService.getPfwOverlayState();
	  }
	
	  /**
	   * @description : Submit the Track Your Delivery form.
	   * @param {String} trackingNumber
	   */
	  function submit(trackingNumber) {
	
	    // Reset error state in the case where user is retrying after validation issue.
	    resetErrors();
	
	    sanitizedTrackingNumber = numberService.sanitize(trackingNumber);
	    applicationModel.sanitizedNumber = angular.copy(sanitizedTrackingNumber);
	    var isValidNumber = numberService.validate(sanitizedTrackingNumber);
	
	    if (isValidNumber === 'checkPFW') {
	
	      isValidNumber = parcelForceService.checkPFW(isValidNumber, sanitizedTrackingNumber);
	    }
	
	    if (isValidNumber === true) {
	
	      var triggerGoogleRecaptchaCheck = configService.google_recaptcha.enabled ? trackingCodeService.triggerGoogleRecaptchaCheck() : false;
	
	      // Set authToken if the parcels_jwt cookie was found and is valid.
	      applicationModel.authToken = parcelsService.isValidCookie() ? $cookies.get('parcels_jwt') : null;
	
	      // Invoke Google Recaptcha if needed, and process the request later.
	      // See processRequestWithGoogleRecaptchaToken below.
	      if (triggerGoogleRecaptchaCheck) {
	
	        googleRecaptchaService.invokeCaptcha();
	      } else {
	
	        processRequest(sanitizedTrackingNumber);
	      }
	    } else if (isValidNumber === 'isPFW') {
	
	      togglePfwOverlay(sanitizedTrackingNumber);
	    } else {
	
	      displayErrors(numberService.errorMessageMap(isValidNumber));
	    }
	  }
	
	  $rootScope.$on('overlayClosed', function () {
	
	    vm.pfwOverlayStatus = overlayService.getPfwOverlayState();
	  });
	
	  $rootScope.$on('externalReSubmit', function (e, id) {
	
	    vm.trackId = numberService.filterNumber(id);
	
	    $timeout(function () {
	
	      submit(id);
	    }, 100);
	  });
	
	  var googleRecaptchaTokenListener = $rootScope.$on('googleRecaptchaTokenAvailable', function (event, googleRecaptchaToken) {
	
	    applicationModel.googleRecaptcha.googleToken = googleRecaptchaToken;
	    processRequest(applicationModel.sanitizedNumber);
	  });
	
	  $scope.$on('$destroy', function () {
	
	    googleRecaptchaTokenListener();
	  });
	
	  function overlayClick() {
	
	    overlayService.toggleOverlay();
	  }
	
	  function clearPlaceHolder() {
	
	    inputElem.setAttribute('placeholder', '');
	  }
	
	  function resetPlaceHolder() {
	
	    var attrVal = configService.messages.tracking_code.tracking_placeholder;
	    inputElem.setAttribute('placeholder', attrVal);
	  }
	
	  /**
	   * @description : Sets the caretPos cursor position for the given element.
	   * @param {Object} elem: HTML element.
	   * @param {Integer} caretPos: Position for the cursor.
	   */
	  function setCaretPosition(elem, caretPos) {
	
	    var range = void 0;
	
	    if (elem !== null) {
	
	      if (elem.createTextRange) {
	
	        range = elem.createTextRange();
	        range.move('character', caretPos);
	        range.select();
	      } else if (elem.selectionStart) {
	
	        elem.focus();
	        elem.setSelectionRange(caretPos, caretPos);
	      } else {
	
	        elem.focus();
	      }
	    }
	  }
	
	  function setTrackingCodeSearch() {
	
	    var code = vm.trackId;
	    // Get the input code original spaces until the initial cursor's position.
	    var originalCodeSpaces = code.substring(0, inputElem.selectionEnd).split(' ').length - 1;
	    // Get cursor position or end of element.
	    var cursorPosition = inputElem.selectionEnd;
	    var formattedCodeSpaces = 0;
	
	    if (code) {
	
	      vm.trackId = numberService.filterNumber(code);
	    } else {
	
	      vm.trackId = code;
	    }
	
	    // Case when entering number and cursor goes to previous after a whitespace.
	    if (inputElem.value.length > 4 && inputElem.selectionEnd === inputElem.value.length) {
	
	      cursorPosition += 1;
	    }
	
	    // Add the formatted spaces to the cursor position counting until the current position of the cursor.
	    formattedCodeSpaces = vm.trackId.substring(0, cursorPosition).split(' ').length - 1;
	    cursorPosition += formattedCodeSpaces - originalCodeSpaces >= 0 ? formattedCodeSpaces - originalCodeSpaces : 0;
	
	    // Set the cursor position after the filterNumber function.
	    // Wrapped in setTimeout to make it work.
	    $timeout(function () {
	
	      setCaretPosition(inputElem, cursorPosition);
	    }, 0);
	  }
	
	  /**
	   * @description : Handle click events outside, to close the popup.
	   * @param {MouseEvent} e: Mouse click event
	   */
	  function handleClose(e) {
	
	    if (vm.pfwOverlayStatus) {
	
	      var popup = document.getElementsByClassName('button-holder');
	      var isClickInside = popup.length > 0 ? popup[0].contains(e.target) : false;
	
	      if (!isClickInside) {
	
	        vm.pfwOverlayStatus = false;
	        overlayService.togglePfwOverlay();
	        $scope.$apply();
	      }
	
	      e.stopPropagation();
	    }
	  }
	
	  /**
	   * @description : Handle key events to close the popup.
	   * @param {Event} e: Keyup event
	   */
	  function handleEsc(e) {
	
	    var evt = e || window.event;
	    var isEscape = 'key' in evt ? evt.key === 'Escape' || evt.key === 'Esc' : evt.keyCode === 27;
	
	    if (isEscape) {
	
	      if (vm.pfwOverlayStatus) {
	
	        vm.pfwOverlayStatus = false;
	        overlayService.togglePfwOverlay();
	        $scope.$apply();
	      }
	    }
	
	    evt.preventDefault();
	  }
	
	  /**
	   * @description : Listen for click/keyup events oustide the overlay popup.
	   */
	  $window.document.addEventListener('mouseup', handleClose, false);
	  $window.document.addEventListener('keyup', handleEsc, false);
	
	  vm.configService = configService;
	  vm.showError = false;
	  vm.errorMessages = [];
	  vm.overlayGetter = overlayService.getOverlayState;
	  vm.pfwOverlayStatus = overlayService.getPfwOverlayState();
	  vm.overlayClick = overlayClick;
	  vm.submit = submit;
	  vm.clearPlaceHolder = clearPlaceHolder;
	  vm.resetPlaceHolder = resetPlaceHolder;
	  checkURLRequest();
	  vm.setTrackingCodeSearch = setTrackingCodeSearch;
	  vm.isLoggedIn = parcelsService.isValidCookie();
	  vm.recaptchaSize = configService.google_recaptcha.widget_size;
	  vm.recaptchaId = configService.google_recaptcha.container;
	  vm.searchPage = searchPage;
	
	  // Send Tealium tags only when needed.
	  if (!errTags && (!applicationModel.urlSearch || applicationModel.urlSearch !== true)) {
	
	    var tags = searchPage(vm.isLoggedIn);
	    tealiumService.sendTags(tags);
	  }
	
	  // Check and call initialise recaptcha on the tracking-code view.
	  function googleRecaptchaInitialise() {
	
	    if (configService.google_recaptcha.enabled && $window.grecaptcha) {
	
	      googleRecaptchaService.initialiseCaptcha(configService.google_recaptcha.container, configService.google_recaptcha.site_key);
	    }
	  }
	
	  // Use timeout 0 here to wait until the DOM is fully loaded.
	  $timeout(function () {
	
	    if ($window.grecaptcha) {
	
	      googleRecaptchaInitialise();
	    } else {
	
	      // Make triggeredByGoogleRecaptcha available in the window object to share with Drupal.
	      $window.triggeredByGoogleRecaptcha = googleRecaptchaInitialise;
	    }
	  });
	}
	
	exports.default = trackingCodeController;

/***/ }),
/* 26 */
/***/ (function(module, exports) {

	module.exports = "<pfw-overlay data-ng-show=\"vm.pfwOverlayStatus\"></pfw-overlay>\n<div class=\"c-tracking-code\">\n  <div class=\"track-errors\" data-ng-show=\"vm.showError\">\n    <div\n      data-ng-repeat=\"error in vm.errorMessages\"\n      class=\"c-error\"\n      data-ng-show=\"vm.showError\">\n      <i class=\"icon-information-red\"></i>\n      {{ error.errorDescription || error }}\n    </div>\n  </div>\n  <form id=\"tracking-code-form\">\n    <div class=\"input-container\">\n      <label for=\"track-item\">Track an item</label>\n      <input\n        id=\"track-item\"\n        name=\"trackingNumber\"\n        type=\"text\"\n        placeholder=\"{{ vm.configService.messages.tracking_code.tracking_placeholder }}\"\n        data-ng-class=\"{'input-error' : vm.showError}\"\n        data-ng-model=\"vm.trackId\"\n        data-ng-focus=\"vm.clearPlaceHolder()\"\n        data-ng-blur=\"vm.resetPlaceHolder()\"\n        maxlength=\"27\">\n      <button\n        id=\"trackdelivery-bt\"\n        name=\"trackdelivery-bt\"\n        value=\"Track Delivery\"\n        data-ng-click=\"vm.submit(vm.trackId)\">\n        <span class=\"track-bt-text\">\n          {{ vm.configService.messages.tracking_code.button_label }}\n        </span>\n        <span class=\"icon-button-arrow\"></span>\n      </button>\n      <googlerecaptcha data-recaptcha-id=\"vm.recaptchaId\" data-recaptcha-size=\"vm.recaptchaSize\"></googlerecaptcha>\n    </div>\n    <a class=\"reference-overlay-link\" href=\"{{ vm.configService.messages.tracking_code.overlay_link_url }}\" target=\"_blank\">\n      {{ vm.configService.messages.tracking_code.overlay_link_text }}\n    </a>\n  </form>\n</div>\n"

/***/ }),
/* 27 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _trackingResults = __webpack_require__(32);
	
	var _trackingResults2 = _interopRequireDefault(_trackingResults);
	
	var _trackingResultsView = __webpack_require__(33);
	
	var _trackingResultsView2 = _interopRequireDefault(_trackingResultsView);
	
	__webpack_require__(34);
	
	__webpack_require__(37);
	
	__webpack_require__(39);
	
	__webpack_require__(41);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var trackingResultsComponent = {
	  template: _trackingResultsView2.default,
	  controller: _trackingResults2.default,
	  controllerAs: 'vm'
	};
	
	exports.default = trackingResultsComponent;

/***/ }),
/* 32 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * @description : Display item state, progress, details and history.
	 * @requires {Object} applicationModel
	 * @requires {Object} configService
	 * @requires {Object} trackingService
	 * @requires {Object} parcelsService
	 * @requires {Object} tealiumService
	 * @requires {Object} numberService
	 * @requires {Function} $interpolate
	 * @requires {Object} $cookies
	 * @requires {Object} $window
	 * @requires {Object} $filter
	 * @requires {Function} $timeout
	 */
	function trackingResultsController(applicationModel, configService, trackingService, parcelsService, tealiumService, numberService, $interpolate, $cookies, $window, $filter, $timeout) {
	
	  var vm = this;
	  var tooltip = null;
	  var imgHolder = null;
	  var counter = 0;
	  vm.imageSrc = '';
	  vm.hidePrintButton = false;
	  vm.hideRotateButton = false;
	  var monthsArr = configService.messages.tracking_results.months.split(',');
	  var daysArr = configService.messages.tracking_results.days.split(',');
	  // This only serves as a reference ordered index to map the weekdays for every other language.
	  var weekDayArr = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
	
	  /**
	   * @description : Convert date/time in UTC
	   * @param {Object} dateToConvert
	   * @returns {Object}
	   */
	  function calcTime(dateToConvert) {
	
	    var offset = '0';
	    var currentDate = new Date();
	    var currentYear = currentDate.getFullYear();
	    var lastDayMarch = new Date(currentYear, 3, 0);
	    var lastSundayMarch = new Date(lastDayMarch.setDate(lastDayMarch.getDate() - (lastDayMarch.getDay() === 0 ? 7 : lastDayMarch.getDay())));
	    var lastDayOct = new Date(currentYear, 10, 0);
	    var lastSundayOct = new Date(lastDayOct.setDate(lastDayOct.getDate() - (lastDayOct.getDay() === 0 ? 7 : lastDayOct.getDay())));
	
	    // Offset will be +1 if current date falls within BST
	    if (currentDate >= lastSundayMarch && currentDate <= lastSundayOct) {
	
	      offset = '+1';
	    }
	
	    // Get UTC time in msec
	    var utc0 = dateToConvert.getTime() + dateToConvert.getTimezoneOffset() * 60000;
	
	    // Create new Date object using supplied offset.
	    var nd = new Date(utc0 + 3600000 * offset);
	
	    return nd;
	  }
	
	  /**
	   * @description : Check for inclusion & exclusion date/time.
	   * @param {Array} schedule
	   * @returns {Boolean}
	   */
	  function checkScheduleInclusionExclusion(schedule) {
	
	    var today = calcTime(new Date());
	
	    for (var i = 0; i < schedule.length; i++) {
	
	      // Set the date/time as require to validate against current date/time.
	      var dateStartTimeObject = new Date(schedule[i].exceptionDate);
	      var dateEndTimeObject = new Date(schedule[i].exceptionDate);
	      dateStartTimeObject.setHours(parseInt(schedule[i].startTime.substr(0, 2), 10), parseInt(schedule[i].startTime.substr(3, 2), 10));
	      dateEndTimeObject.setHours(parseInt(schedule[i].endTime.substr(0, 2), 10), parseInt(schedule[i].endTime.substr(3, 2), 10));
	
	      dateStartTimeObject = calcTime(dateStartTimeObject);
	      dateEndTimeObject = calcTime(dateEndTimeObject);
	
	      // "inclusions": [{"exceptionDate": "2018-11-23", "startTime":"07:00", "endTime":"22:30"}]
	      // If current date/time falls under inclusion start & end date/time,
	      // then display chatbot window.
	
	      // "exclusions": [
	      //   {"exceptionDate": "2018-11-20", "startTime":"08:00", "endTime":"17:30"}
	      //   {"exceptionDate": "2018-12-25", "startTime":"08:00", "endTime":"19:30"}
	      // ]
	
	      // If current date/time doesn't fall under exclusions defined date/time,
	      // then display chatbot.
	      // e.g. If current date/time is 2018-11-20 / 18:00pm which doesn't fall under
	      // defined exclusions as {"exceptionDate": "2018-11-20", "startTime":"08:00", "endTime":"17:30"}
	      // then display chatbot window.
	
	      if (today >= dateStartTimeObject && today <= dateEndTimeObject) {
	
	        return true;
	      }
	    }
	
	    return false;
	  }
	
	  /**
	   * @description : Check operating hours for chatbot.
	   * @param {Object} chatbotWidgetOpHours
	   * @returns {Integer}
	   */
	  function displayChatbotOpHours(chatbotWidgetOpHours) {
	
	    var displayChatbot = false;
	    var today = new Date();
	    var day = weekDayArr[today.getDay()];
	
	    // Create date objects and set the time as require.
	    var startTimeObject = new Date(today);
	    var endTimeObject = new Date(today);
	
	    // Convert to require timezone.
	    today = calcTime(today);
	    startTimeObject = calcTime(startTimeObject);
	    endTimeObject = calcTime(endTimeObject);
	
	    // Loop through JSON array.
	    /*eslint-disable */
	    angular.forEach(chatbotWidgetOpHours.operatingSchedules.schedule, function (value, index) {
	
	      // Check for inclusion dates.
	
	      // "inclusions": [{"exceptionDate": "2018-11-23", "startTime":"07:00", "endTime":"22:30"}]
	      // If current date/time falls under inclusion start & end date/time,
	      // then display chatbot window.
	
	      displayChatbot = checkScheduleInclusionExclusion(chatbotWidgetOpHours.operatingSchedules.schedule[index].inclusions);
	
	      if (!displayChatbot) {
	
	        // Check for normal days excluding date/time in exclusions.
	        // "operatingHours": [
	        // {"dayOfWeek":"Monday", "startTime":"08:00", "endTime":"19:30" },
	        // {"dayOfWeek":"Tuesday", "startTime":"08:00", "endTime":"19:30" }]
	        // "exclusions": [
	        //   {"exceptionDate": "2018-11-20", "startTime":"08:00", "endTime":"17:30"}
	        //   {"exceptionDate": "2018-12-25", "startTime":"08:00", "endTime":"19:30"}
	        // ]
	
	        // e.g. If current day is "Tuesday" with operating hours as 8:00am to 19:30pm
	        // & exclusion has current date (2018-11-20) which falls on "Tuesday"
	        // with operating hours as 8:00am to 17:30pm.
	        // Then chatbot window should be displayed only within 17:30pm to 19:30pm on
	        // date 2018-11-20.
	
	        var opHours = chatbotWidgetOpHours.operatingSchedules.schedule[index].operatingHours;
	        for (var i = 0; i < opHours.length; i++) {
	
	          // Set the date/time as require to validate against current date/time.
	          startTimeObject.setHours(parseInt(opHours[i].startTime.substr(0, 2), 10), parseInt(opHours[i].startTime.substr(3, 2), 10));
	          endTimeObject.setHours(parseInt(opHours[i].endTime.substr(0, 2), 10), parseInt(opHours[i].endTime.substr(3, 2), 10));
	
	          // If current day falls under normal days defined hours,
	          // then display chatbot.
	
	          // e.g If current day is "Monday" & current time is 9:00 am which
	          // falls under the defined operating hours as
	          // {"dayOfWeek":"Monday", "startTime":"08:00", "endTime":"19:30" }
	
	          if (day === opHours[i].dayOfWeek && today >= startTimeObject && today <= endTimeObject) {
	
	            displayChatbot = true;
	            break;
	          }
	        }
	
	        if (displayChatbot) {
	
	          // Check for excluded date.
	
	          // "exclusions": [
	          //   {"exceptionDate": "2018-11-20", "startTime":"08:00", "endTime":"17:30"}
	          //   {"exceptionDate": "2018-12-25", "startTime":"08:00", "endTime":"19:30"}
	          // ]
	
	          // If current date/time doesn't fall under exclusions defined date/time,
	          // then display chatbot.
	          // e.g. If current date/time is 2018-11-20 / 18:00pm which doesn't fall under
	          // defined exclusions as {"exceptionDate": "2018-11-20", "startTime":"08:00", "endTime":"17:30"}
	          // then display chatbot window.
	
	          displayChatbot = !checkScheduleInclusionExclusion(chatbotWidgetOpHours.operatingSchedules.schedule[index].exclusions);
	        }
	      }
	    });
	    /*eslint-disable */
	
	    return displayChatbot;
	  }
	
	  if (angular.isDefined(applicationModel.trackingDetails.mailPieces)) {
	
	    var chatbotFrequency = configService.chatbot.chatbotFrequency;
	    var chatbotWidgetLibURL = configService.chatbot.chatbotWidgetLibURL;
	    var chatbotWidgetTimeDelay = configService.chatbot.chatbotTimeDelay;
	    var chatbotWidgetOpJson = configService.chatbot.chatbotWidgetOpJson;
	    var chatbotInServicePeriod = false;
	
	    // Check if current date/time falls under chatbot configured operating hours.
	    if (chatbotWidgetOpJson) {
	
	      var chatbotWidgetOpHours = angular.fromJson(chatbotWidgetOpJson);
	      chatbotInServicePeriod = displayChatbotOpHours(chatbotWidgetOpHours);
	    }
	
	    if ((parseInt(chatbotFrequency, 10) === 1 || Math.random() < chatbotFrequency) && chatbotInServicePeriod === true) {
	
	      if (!document.getElementById('flmntChatbot')) {
	
	        // Show chatbot after a delay of 20 seconds.
	        $timeout(function () {
	
	          var script = document.createElement('script');
	          angular.element(document.body).append('<div id="flmnt-placeholder"></div>');
	          var placeholder = document.getElementById('flmnt-placeholder');
	          script.type = 'text/javascript';
	          script.async = true;
	          script.src = chatbotWidgetLibURL;
	          placeholder.appendChild(script);
	        }, chatbotWidgetTimeDelay);
	      }
	
	      /*eslint-disable */
	      var eventDate = applicationModel.trackingDetails.mailPieces.summary.lastEventDateTime;
	      var eventStatus = applicationModel.trackingDetails.mailPieces.summary.statusCategory;
	      var eventSummary = applicationModel.trackingDetails.mailPieces.summary.summaryLine;
	      var eventCode = applicationModel.trackingDetails.mailPieces.events[0].eventCode;
	      angular.element(document.body).append('<div id="flmntWidgetInit" ' + ' flmnt-proxy="' + configService.chatbot.chatbotWidgetProxyUrl + '"' + ' flmnt-widgettitle="' + configService.chatbot.chatbotWidgetTitle + '"' + ' flmnt-widgetplaceholder="' + configService.chatbot.chatbotWidgetPlaceholder + '"' + ' flmnt-widgeticonurl="' + configService.chatbot.chatbotWidgetIconUrl + '"' + ' flmnt-widgettab="' + configService.chatbot.chatbotWidgetTabTitle + '"' + ' flmnt-widgeterror="' + configService.chatbot.chatbotWidgetError + '"' + ' flmnt-widgeturl="' + configService.chatbot.chatbotWidgetURL + '"' + ' flmnt-trackingnumber="' + applicationModel.trackingDetails.mailPieces.mailPieceId + '"' + ' flmnt-trackingstatus="' + eventStatus + '"' + ' flmnt-trackingsummary="' + eventSummary + '"' + ' flmnt-trackingeventcode="' + eventCode + '"' + ' flmnt-trackingdate="' + eventDate + '"' + '></div>');
	      /*eslint-disable */
	    }
	  }
	
	  // Set tealiumService
	  var persistentTags = {
	
	    pageApplicationName: configService.tealium.app_name,
	    pagePersona: configService.tealium.instance.toLowerCase(),
	    pageLanguage: document.documentElement.lang === 'en' ? 'en-gb' : document.documentElement.lang
	
	  };
	
	  $window.scrollTo(0, 0);
	
	  tealiumService.setBaseTags(persistentTags);
	
	  /**
	   * @description : generates tealium tags for this page.
	   * @param {Boolean} isLoggedIn
	   * @param {Object} response : parcel item details.
	   * @returns {Object}
	   */
	  function resultsPage(isLoggedIn) {
	    var response = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	
	    var cookie = $cookies.get('parcels_jwt');
	    var JWT = parcelsService.decodeJWT(cookie);
	    var breadCrumb = parcelsService.isSet(configService, 'breadcrumbs') ? JSON.parse(configService.breadcrumbs) : '';
	    var now = parcelsService.formatDate(new Date());
	    var isInflightEnabled = displayInflightOption();
	
	    // Override default tags when redelivery option available.
	    var step = isInflightEnabled ? 'Result with Delivery Options' : 'Result';
	
	    var tags = {
	      pageName: configService.tealium.site_prefix + ' >' + configService.tealium.instance + ' >Track Your Items >' + step,
	      pageMenuTree: configService.tealium.instance + '|Track Your Items|' + step,
	      pageApplicationStep: step,
	      pageTemplate: 'Results Screen',
	      pageBreadCrumb: Array.isArray(breadCrumb) && breadCrumb.length > 1 ? breadCrumb.join('|') : breadCrumb.toString(),
	      conversionID: parcelsService.isSet(response, 'mailPieceId'),
	      conversionDate: now.date,
	      conversionType: 'Tracking Result',
	      conversionProduct: {
	        productSKU: parcelsService.isSet(response, 'mailPieceId'),
	        productCategory: 'Track and Trace',
	        productQuantity: 1,
	        productAttributes: {
	          carrierName: parcelsService.isSet(response, 'carrierShortName'),
	          serviceName: parcelsService.isSet(response.summary, 'productName'),
	          countryCode: parcelsService.isSet(response.summary, 'destinationCountryCode'),
	          originCountryCode: parcelsService.isSet(response.summary, 'originCountryCode'),
	          itemStatus: parcelsService.isSet(response.summary, 'statusDescription'),
	          itemStatusCode: parcelsService.isSet(response.summary, 'lastEventCode'),
	          itemStatusEDW: parcelsService.isSet(response, 'estimatedDelivery') ? '1' : '0',
	          mapStatus: '0'
	        }
	      }
	    };
	
	    var userTags = {
	      visitorGUID: parcelsService.isSet(JWT, 'sub'),
	      visitorEmail: parcelsService.isSet(JWT, 'email'),
	      visitorSegment: parcelsService.isSet(JWT, 'visitorSegment'),
	      visitorRMPPost: parcelsService.isSet(JWT, 'visitorRMPPost'),
	      visitorRMPPhone: parcelsService.isSet(JWT, 'visitorRMPPhone'),
	      visitorRMPEmail: parcelsService.isSet(JWT, 'visitorRMPEmail'),
	      visitorRMPOther: parcelsService.isSet(JWT, 'visitorRMPOther')
	    };
	
	    if (isInflightEnabled) {
	
	      tags.conversionProduct.productAttributes.changeDeliveryOptions = '1';
	      tags.pageBreadCrumb = 'Home|Track Your Items|Result with Delivery Options';
	      tags.pageAttributes = 'Choose Delivery Options';
	    }
	
	    if (isGPSOptionEnabled()) {
	
	      var pageAttribute = isInflightEnabled ? tags.pageAttributes + '|' : '';
	      tags.pageAttributes = pageAttribute + 'Map available';
	      tags.conversionProduct.productAttributes.mapStatus = '1';
	    }
	
	    if (isLoggedIn) return angular.merge(tags, userTags);
	
	    return tags;
	  }
	
	  /**
	   * @description: Check if item has Signature in api response.
	   * @returns  {Boolean}
	   */
	  // TODO : Remove after backword compatability in later version v3.x
	  function hasSignature() {
	
	    var hasElement = parcelsService.checkNested(vm.trackingDetails, 'links', 'signatureimage', 'href');
	    return hasElement && vm.trackingDetails.links.signatureimage.href !== '';
	  }
	
	  /**
	   * @description: Check if item has image node in api response.
	   * @returns  {Boolean}
	   */
	  function hasImage() {
	
	    var hasElement = parcelsService.checkNested(vm.trackingDetails, 'links', 'image', 'href');
	    return hasElement && vm.trackingDetails.links.image.href !== '';
	  }
	
	  /**
	   * @description: Check if item has deliveryChangeOptions node in response.
	   * @returns {Boolean}
	   */
	  function hasDeliveryChangeOption() {
	
	    var hasElemnt = parcelsService.checkNested(vm.trackingDetails, 'links', 'deliverychangeoption', 'href');
	    return hasElemnt && vm.trackingDetails.links.deliverychangeoption.href !== '';
	  }
	
	  /**
	   * @description: Check if Parcelforce item.
	   * @returns  {Boolean}
	   */
	  function isPFW() {
	
	    return 'carrierShortName' in vm.trackingDetails && vm.trackingDetails.carrierShortName === 'PFW';
	  }
	
	  /**
	   * @description: Get the signature image.
	   */
	  function getSignatureImage() {
	
	    return hasImage() ? vm.trackingDetails.links.image.href : vm.trackingDetails.links.signatureimage.href;
	  }
	
	  /**
	   * @description : Convert/format dates to other languages (EEEE/d/MMMM) e.g. Dydd Llun 13 Medi.
	   * @param {String} date A date string provided by the API as "2016-11-20T10:04:00+01:00".
	   * @returns {String} date.
	   */
	  function convertDate(date) {
	
	    // We use angular to format the date objects then translate the parts with vanilla JS.
	    var formattedDate = $filter('date')(parcelsService.ignoreTimezone(date), 'EEEE d MMMM');
	    var weekDay = formattedDate.split(' ')[0];
	    var weekDayIndex = weekDayArr.indexOf(weekDay);
	    var dateArray = date.substr(0, 10).split('-');
	    var month = parseInt(dateArray[1], 10) - 1;
	    var day = dateArray[2];
	
	    return daysArr[weekDayIndex].trim() + ' ' + day.trim() + ' ' + monthsArr[month].trim();
	  }
	
	  function getTrackingHistory() {
	
	    var history = {};
	    var count = 0;
	
	    if (vm.trackingDetails && vm.trackingDetails.events) {
	
	      vm.trackingDetails.events.forEach(function (msg) {
	
	        if (!Array.isArray(history[msg.eventDateTime])) history[msg.eventDateTime] = [];
	
	        if (count === 0) history[msg.eventDateTime].isFirstDay = true;
	
	        history[msg.eventDateTime].push(msg);
	        count += 1;
	      });
	      return history;
	    }
	
	    return false;
	  }
	
	  function expandTrackingHistory() {
	
	    vm.showExtendedHistory = !vm.showExtendedHistory;
	  }
	
	  function getToggleClass(state) {
	
	    return state ? 'expanded' : 'collapsed';
	  }
	  /**
	   * @description: Get rotation style for pod image.
	   */
	  function getRotationStyle() {
	
	    if (vm.rotationAngle === '90deg' || vm.rotationAngle === '270deg') {
	
	      vm.rotationStyle = {
	
	        padding: '15px',
	        'max-width': '95%',
	        transform: 'rotate(' + vm.rotationAngle + ')',
	        '-webkit-transform': 'rotate(' + vm.rotationAngle + ')',
	        '-moz-transform': 'rotate(' + vm.rotationAngle + ')',
	        '-ms-transform': 'rotate(' + vm.rotationAngle + ')',
	        '-o-transform': 'rotate(' + vm.rotationAngle + ')'
	
	      };
	    } else {
	
	      vm.rotationStyle = {
	
	        'max-width': '95%',
	        transform: 'rotate(' + vm.rotationAngle + ')',
	        '-webkit-transform': 'rotate(' + vm.rotationAngle + ')',
	        '-moz-transform': 'rotate(' + vm.rotationAngle + ')',
	        '-ms-transform': 'rotate(' + vm.rotationAngle + ')',
	        '-o-transform': 'rotate(' + vm.rotationAngle + ')'
	
	      };
	    }
	  }
	
	  /**
	   * @description: Open print preview in new window.
	   */
	  function printPage() {
	
	    getRotationStyle();
	    $timeout(function () {
	
	      var location = /\w#print\b/ig.test($window.location.hash) ? window.location.href : $window.location.href + '#print';
	      var innerContents = angular.element(document.querySelector('#printView'))[0].innerHTML;
	      var printTitle = vm.configService.messages.pod_print.sub_header;
	      var printWindow = $window.open(location, '_blank');
	      printWindow.document.open();
	      printWindow.document.write('<html><head><meta charset="UTF-8"><title>' + printTitle + '\n      </title></head><body onload="window.print()">' + innerContents + '</body></html>');
	      printWindow.document.close();
	      printWindow.location = location;
	    }, 10);
	  }
	
	  /**
	   * @description: Sets the state for Extended Footer.
	   * @param {Array|Boolean} trackingHistory : Tracking History is either false
	   * or an array.
	   * @returns {Boolean} : If the Extended Fotter should be shown.
	   */
	  function getExtendedFooterState(trackingHistory) {
	
	    var state = false;
	
	    // IE has an issue with empty Objects and Object.keys
	    // so we will check if trackingHistory is false first.
	    if (trackingHistory === false) {
	
	      return state;
	    } else if (Object.keys(trackingHistory).length > 1) {
	
	      state = true;
	    }
	
	    return state;
	  }
	
	  /**
	   * @description: Check if country code is UK.
	   * @param {String} code : The country code.
	   * @returns {Boolean} : If the code is UK or not.
	   */
	  function isUkCode(code) {
	
	    return code.trim() === 'GBR' || code.trim() === 'GB';
	  }
	
	  /**
	   * @description: Check if Redelivery button should be displayed.
	   * @returns {Boolean} : If the Redelivery button should be displayed.
	   */
	  function displayRedelivery() {
	
	    return vm.trackingDetails && vm.trackingDetails.summary.statusCategory === configService.api.status_cat_value_mapping.delivery_attempted && vm.trackingDetails.summary.destinationCountryCode && isUkCode(vm.trackingDetails.summary.destinationCountryCode);
	  }
	
	  /**
	   * @description: Check if Inflight redelivery option button should be displayed.
	   * @returns {Boolean}: If the Inflight redelivery option should be displayed.
	   */
	  function displayInflightOption() {
	
	    return hasDeliveryChangeOption() && vm.configService.misc.tracking_results_inflight_enabled;
	  }
	
	  /**
	   * @description: Construct URL for inflight redelivery.
	   * @returns: inflight redelivery landing page url.
	   */
	  function inflightUrl() {
	
	    var url = vm.configService.messages.redelivery.inflight_url + '?' + vm.configService.messages.redelivery.query_param + '=' + vm.trackingDetails.mailPieceId;
	    window.location.href = url;
	  }
	
	  /**
	   * @description: Get the session token from the applicationModel
	   * @returns {String} : the current session token.
	   */
	  function getRecaptchaSession() {
	
	    return applicationModel.googleRecaptcha.sessionToken;
	  }
	
	  /**
	   * @description : Check if image exist.
	   * @return {Boolean}
	   */
	  function isImageExist() {
	
	    imgHolder = angular.element(document.querySelector('#picture-blob-holder'));
	    if (imgHolder.length > 0) {
	
	      imgHolder = imgHolder[0].childNodes[1];
	      return imgHolder.nodeName === 'IMG';
	    }
	    return false;
	  }
	
	  /**
	   * @description: Rotate image clockwise 90 degree on each click.
	   */
	  function rotateImage() {
	
	    if (isImageExist()) {
	
	      // Remove all classes applied to image object.
	      imgHolder.classList.remove('rotate-90', 'rotate-180', 'rotate-270', 'rotate-360');
	      // IE Fix: Setting classname of image to empty as IE is not removing class from classList.
	      imgHolder.className = '';
	      vm.rotationAngle = '0deg';
	      // Calculate marging from image/signature to fit in container on rotation.
	      var imgWidth = imgHolder.offsetWidth;
	      var imgHeight = imgHolder.height;
	      var imgMargin = imgWidth > imgHeight ? (imgWidth - imgHeight) / 2 : 0;
	      imgHolder.style.marginBottom = '0';
	      imgHolder.style.marginTop = '0';
	      counter += 1;
	      switch (counter) {
	
	        case 1:
	          imgHolder.classList.add('rotate-90');
	          imgHolder.style.marginBottom = imgMargin + 'px';
	          imgHolder.style.marginTop = imgMargin + 'px';
	          vm.rotationAngle = '90deg';
	          break;
	        case 2:
	          imgHolder.classList.add('rotate-180');
	          vm.rotationAngle = '180deg';
	          break;
	        case 3:
	          imgHolder.classList.add('rotate-270');
	          imgHolder.style.marginBottom = imgMargin + 'px';
	          imgHolder.style.marginTop = imgMargin + 'px';
	          vm.rotationAngle = '270deg';
	          break;
	        default:
	          imgHolder.classList.add('rotate-360');
	          counter = 0;
	          break;
	
	      }
	    }
	  }
	
	  /**
	   * @description : Display error in image place holder and hide print and rotate button.
	   */
	  function handleImageError() {
	
	    var para = document.createElement('p');
	    var node = document.createTextNode(configService.messages.tracking_results.pod_image_error);
	    para.appendChild(node);
	    angular.element(document.querySelector('#picture-blob-holder')).append(para);
	
	    vm.hideRotateButton = true;
	    vm.hidePrintButton = true;
	  }
	
	  /**
	   * @description: Currently cookies are required to retrieve the signature,
	   * but when a browser blocks third party cookies we must set
	   * a header and retrieve the image via a get request and create an element to
	   * append to the view.
	   */
	  function renderSignature() {
	
	    // TODO remove deprecated x-recaptcha-session once APIm 3.2 is deployed.
	    trackingService.getSignature(getSignatureImage(), {
	      'x-recaptcha-session': getRecaptchaSession(),
	      'X-RMG-API-Session': getRecaptchaSession()
	    }).then(function (response) {
	
	      // Check if image blob  exist then add image.
	      if (response.data.size > 0) {
	
	        var img = document.createElement('img');
	        img.onload = function () {
	
	          $window.URL.revokeObjectURL(img.src);
	        };
	
	        img.src = window.URL.createObjectURL(response.data);
	        vm.imageSrc = window.URL.createObjectURL(response.data);
	        angular.element(document.querySelector('#picture-blob-holder')).append(img);
	      } else {
	
	        handleImageError();
	      }
	    }).catch(function () {
	
	      handleImageError();
	    });
	  }
	
	  /**
	   * @description: Check if pod image exist and rendered on page.
	   * @returns {Boolean}
	   */
	  function isImageRendered() {
	
	    return vm.imageSrc !== '' || vm.imageSrc !== undefined || vm.imageSrc !== null;
	  }
	
	  /**
	   * @description: Show/hide buttons
	   * @param {Boolean} isHidden
	   * @return {Boolean}
	   */
	  function showButton(isHidden) {
	
	    return vm.trackingDetails && (vm.trackingDetails.links.signatureimage || vm.trackingDetails.links.image) && !isHidden;
	  }
	
	  /**
	   * @description: Check if the Start Estimate for EDW
	   * @param {String} time : The startDate for the EDW
	   * @returns {Boolean} : If we show the start window or not.
	   */
	  function hasValidStartEstimate(time) {
	
	    if ($filter('formatTime')(time) === '12:00am' || $filter('formatTime')(time) === '00:00am') {
	
	      return false;
	    }
	
	    return true;
	  }
	
	  /**
	   * @description: Check if given date is future date.
	   * @param {Date} edDate
	   * @return {Boolean}
	   */
	  function isFutureDate(edDate) {
	
	    var todayDate = new Date();
	    var deliveryDate = new Date(edDate);
	    return todayDate < deliveryDate;
	  }
	
	  /**
	   * @description Custom predicted delivery date message.
	   */
	  function setPDDMessage() {
	
	    if (!vm.estimatedDelivery || !vm.estimatedDelivery.date) {
	
	      return '';
	    }
	
	    var futureDate = isFutureDate(vm.estimatedDelivery.date);
	    var eddMessage = '';
	
	    // Neither start time nor end time node present.
	    var startEndTimeNodeNotPresent = !vm.estimatedDelivery.startOfEstimatedWindow && !vm.estimatedDelivery.endOfEstimatedWindow;
	
	    // Start and end time node with valid time.
	    var validStartAndEndTime = !startEndTimeNodeNotPresent && vm.hasValidStartEstimate(vm.estimatedDelivery.endOfEstimatedWindow) && vm.hasValidStartEstimate(vm.estimatedDelivery.startOfEstimatedWindow);
	
	    // Only end time node with valid time.
	    var validEndTime = !startEndTimeNodeNotPresent && vm.hasValidStartEstimate(vm.estimatedDelivery.endOfEstimatedWindow) && !vm.hasValidStartEstimate(vm.estimatedDelivery.startOfEstimatedWindow);
	
	    switch (futureDate) {
	
	      case false:
	
	        if (startEndTimeNodeNotPresent) {
	
	          eddMessage = vm.configService.messages.summary_line_edw.no_start_end_text;
	        } else if (validStartAndEndTime) {
	
	          eddMessage = vm.configService.messages.summary_line_edw.initial_text + '\n           ' + $filter('formatTime')(vm.estimatedDelivery.startOfEstimatedWindow) + ' -\n           ' + $filter('formatTime')(vm.estimatedDelivery.endOfEstimatedWindow);
	        } else if (validEndTime) {
	
	          eddMessage = vm.configService.messages.summary_line_edw.no_start_text + '\n           ' + $filter('formatTime')(vm.estimatedDelivery.endOfEstimatedWindow);
	        }
	
	        break;
	
	      case true:
	
	        if (startEndTimeNodeNotPresent) {
	
	          eddMessage = vm.configService.messages.summary_line_edw.future_start_end_text + '\n          ' + $filter('date')(new Date(vm.estimatedDelivery.date), vm.configService.messages.summary_line_edw.date_format);
	        } else if (validStartAndEndTime) {
	
	          eddMessage = vm.configService.messages.summary_line_edw.future_start_end_text + '\n          ' + $filter('date')(new Date(vm.estimatedDelivery.date), vm.configService.messages.summary_line_edw.date_format) + '\n          ' + vm.configService.messages.summary_line_edw.between + '\n          ' + $filter('formatTime')(vm.estimatedDelivery.startOfEstimatedWindow) + ' -\n          ' + $filter('formatTime')(vm.estimatedDelivery.endOfEstimatedWindow);
	        } else if (validEndTime) {
	
	          eddMessage = vm.configService.messages.summary_line_edw.future_start_end_text + '\n          ' + $filter('date')(new Date(vm.estimatedDelivery.date), vm.configService.messages.summary_line_edw.date_format) + '\n          ' + vm.configService.messages.summary_line_edw.by + '\n          ' + $filter('formatTime')(vm.estimatedDelivery.endOfEstimatedWindow);
	        }
	
	        break;
	
	      default:
	
	        eddMessage = '';
	
	        break;
	
	    }
	
	    return eddMessage;
	  }
	
	  /**
	   * @description: Toggle tooltip class.
	   * @param {Boolean} : Is tooltip icon leftOffset near to left edge of screen.
	   * @param {String} : Class name of css.
	   */
	  function toggleTooltipClass(leftOffset) {
	
	    return leftOffset ? 'right-align-tooltip' : 'left-align-tooltip';
	  }
	
	  /**
	   * @description: Assign class after calculating left offset of tooltip.
	   */
	  function assignClass() {
	
	    tooltip = angular.element(document.querySelector('#app .icon-tooltip'));
	    if (tooltip.length > 0) {
	
	      tooltip = tooltip[0];
	      // Calculate tooltip position is in left or right of middle of screen.
	      var tooltipOffset = tooltip.offsetLeft < document.body.offsetWidth / 2;
	      tooltip.classList.remove('left-align-tooltip', 'right-align-tooltip');
	      tooltip.classList.add(toggleTooltipClass(tooltipOffset));
	    }
	  }
	
	  /**
	   * @description: Attach event listeners for pointer devices e.g. iPad, pen tablets,...
	   * so we can handle :hover actions with tap/touch.
	   */
	  function attachPointerEvents() {
	
	    tooltip = angular.element(document.querySelector('#app .icon-tooltip'));
	
	    function touchAdd() {
	
	      tooltip.classList.add('icon-tooltip-hover');
	    }
	
	    function touchRemove() {
	
	      tooltip.classList.remove('icon-tooltip-hover');
	    }
	
	    // Check if tooltip exists on screen.
	    if (tooltip.length > 0) {
	
	      tooltip = tooltip[0];
	
	      // Check if pointer events are supported.
	      if (window.PointerEvent) {
	
	        // Add Pointer Event Listener.
	        $window.document.addEventListener('pointerdown', touchAdd, true);
	        $window.document.addEventListener('pointermove', touchAdd, true);
	        $window.document.addEventListener('pointerup', touchRemove, true);
	      } else if (window.TouchEvent) {
	
	        // Add Touch Event Listener.
	        $window.document.addEventListener('touchstart', touchAdd, true);
	        $window.document.addEventListener('touchmove', touchAdd, true);
	        $window.document.addEventListener('touchend', touchRemove, true);
	      }
	    }
	  }
	
	  // Add some fields of the Tracking Response to a global variable to allow
	  // other elements on the page (e.g: Knowledge base widget)
	  // to use the results.
	  if (parcelsService.isSet(applicationModel.trackingDetails, 'mailPieces')) {
	
	    $window.parcelsTrackingResponse = {
	      statusCategory: parcelsService.isSet(applicationModel.trackingDetails.mailPieces.summary, 'statusCategory'),
	      productName: parcelsService.isSet(applicationModel.trackingDetails.mailPieces.summary, 'productName'),
	      productCategory: parcelsService.isSet(applicationModel.trackingDetails.mailPieces.summary, 'productCategory')
	    };
	  }
	
	  /**
	   * Checking of GPS map feature enabled or not
	   * @returns {Boolean}
	   */
	  function isGPSOptionEnabled() {
	
	    return vm.configService.misc.tracking_results_gps_enabled && parcelsService.checkNested(vm.trackingDetails, 'position', 'longitude') && numberService.areValidCoordinates(vm.trackingDetails.position.latitude, vm.trackingDetails.position.longitude);
	  }
	
	  // Assign tooltip class on page load.
	  angular.element(document).ready(function () {
	    return assignClass();
	  });
	  applicationModel.urlRefresh = true;
	  applicationModel.urlSearch = false;
	  vm.trackingDetails = applicationModel.trackingDetails.mailPieces;
	  vm.markdownToHTML = parcelsService.markdownToHTML;
	  vm.estimatedDelivery = applicationModel.estimatedDelivery;
	  vm.trackingHistory = getTrackingHistory();
	  vm.showExtendedFooter = getExtendedFooterState(vm.trackingHistory);
	  vm.showExtendedHistory = false;
	  vm.expandTrackingHistory = expandTrackingHistory;
	  vm.getToggleClass = getToggleClass;
	  vm.printPage = printPage;
	  vm.rotateImage = rotateImage;
	  vm.hasSignature = hasSignature;
	  vm.hasImage = hasImage;
	  vm.isImageRendered = isImageRendered;
	  vm.getSignatureImage = getSignatureImage;
	  vm.showButton = showButton;
	  vm.signatureImage = hasSignature() || hasImage() ? getSignatureImage() : false;
	  vm.PFWLimitedHistory = configService.messages.pfw.limited_history;
	  vm.parcelflown = configService.messages.parcelflown;
	  vm.isPFW = isPFW;
	  vm.trackingHistoryText = configService.messages.tracking_results;
	  vm.configService = configService;
	  vm.isLoggedIn = parcelsService.isValidCookie();
	  vm.resultsPage = resultsPage;
	  vm.isUkCode = isUkCode;
	  vm.displayRedelivery = displayRedelivery;
	  vm.displayInflightOption = displayInflightOption;
	  vm.inflightUrl = inflightUrl;
	  vm.convertDate = convertDate;
	  vm.ignoreTimezone = parcelsService.ignoreTimezone;
	  $timeout(function () {
	    return attachPointerEvents();
	  }, 0);
	  $timeout(function () {
	    return $window.addEventListener('resize', assignClass, true);
	  }, 0);
	  vm.getRecaptchaSession = getRecaptchaSession;
	  vm.renderSignature = renderSignature;
	  vm.hasValidStartEstimate = hasValidStartEstimate;
	  vm.isFutureDate = isFutureDate;
	  vm.setPDDMessage = setPDDMessage;
	  vm.isGPSOptionEnabled = isGPSOptionEnabled;
	
	  // Send Tealium tags only if the API response has no errors.
	  if (!applicationModel.urlRequest || !applicationModel.urlRequest.error) {
	    var tags = resultsPage(vm.isLoggedIn, vm.trackingDetails);
	
	    tealiumService.sendTags(tags);
	  }
	}
	
	exports.default = trackingResultsController;

/***/ }),
/* 33 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"l-tracking-results\">\n  <div class=\"m-tracking-results\">\n    <div class=\"tracking-another\" data-ng-if=\"vm.configService.misc.inline_track_another_enabled\">\n      <a href=\"#/\">\n        {{ vm.configService.messages.tracking_another.track_another }}\n        <i class=\"icon-track-another\"></i>\n      </a>\n    </div>\n    <header>\n      <span data-ng-if=\"vm.trackingDetails.summary.statusCategory\">\n        <i data-ng-class=\"vm.trackingDetails.summary.statusCategory | statusCategoryFilter\"></i>\n        <span class=\"title\"\n          data-ng-bind-html=\"vm.markdownToHTML(vm.trackingDetails.summary.statusDescription)\">\n        </span>\n      </span>\n    </header>\n    <section>\n      <div>\n        <p class=\"tracking-number-wrapper\">\n          <span data-ng-bind=\"vm.configService.messages.tracking_results.tracking_code_text\"></span>\n          <span\n            class=\"tracking-number-value\"\n            data-ng-bind=\"vm.trackingDetails.mailPieceId\"></span>\n        </p>\n        <p class=\"tracking-summary\">\n          <span\n            data-ng-bind-html=\"vm.markdownToHTML(vm.trackingDetails.summary.summaryLine)\"\n            data-ng-if=\"vm.trackingDetails.summary.summaryLine\">\n          </span>\n          <span class=\"estimated-delivery\" data-ng-if=\"vm.setPDDMessage() !== ''\">\n            {{ vm.setPDDMessage() }}\n          </span>         \n        </p>\n        <span class=\"redelivery-link\"\n          data-ng-if=\"vm.displayRedelivery() && !vm.displayInflightOption()\">\n          <a\n            data-ng-href=\"{{ vm.configService.messages.redelivery.link ? vm.configService.messages.redelivery.link : 'personal/receiving-mail/redelivery' }}\"\n            data-ng-bind=\"vm.configService.messages.redelivery.button_redelivery_options\"></a>\n        </span>\n      </div>\n    </section>\n  </div>\n  <div class=\"m-tracking-details\">\n    <section class=\"c-delivery-details\">\n      <div data-ng-if=\"vm.trackingDetails.summary.originCountryName && vm.trackingDetails.summary.originCountryCode && !vm.isUkCode(vm.trackingDetails.summary.originCountryCode)\">\n        <span class=\"origin-country-label\">\n          {{ vm.configService.messages.tracking_results.sent_from ? vm.configService.messages.tracking_results.sent_from : 'Sent from:'}}\n        </span>\n        <p\n          class=\"origin-country\"\n          data-ng-bind=\"vm.trackingDetails.summary.originCountryName\"></p>\n      </div>\n      <div data-ng-if=\"vm.trackingDetails.summary.destinationCountryName && vm.trackingDetails.summary.destinationCountryCode && !vm.isUkCode(vm.trackingDetails.summary.destinationCountryCode)\">\n        <span class=\"destination-country-label\">\n          {{ vm.configService.messages.tracking_results.going_to ? vm.configService.messages.tracking_results.going_to : 'Going to:'}}\n        </span>\n        <p\n          class=\"destination-country\"\n          data-ng-bind=\"vm.trackingDetails.summary.destinationCountryName\">\n        </p>\n      </div>\n      <div class=\"product-information\" data-ng-if=\"vm.trackingDetails.summary.productName\" >\n        <p>{{ vm.configService.messages.tracking_results.service_used }}</p>\n        <p class=\"icon-tooltip-container\">\n          <span class=\"product-name\">\n              {{ vm.trackingDetails.summary.productName }}\n          </span>\n          <span class=\"icon-tooltip\" data-ng-if=\"vm.trackingDetails.summary.productDescription\">\n            <span class=\"icon-tooltip-text\">\n              <span class=\"icon-tool-tip-point\"></span>\n              {{ vm.trackingDetails.summary.productDescription }}\n            </span>\n          </span>\n        </p>\n      </div>\n      <div>\n        <button data-ng-if=\"vm.displayInflightOption()\" class=\"inflight-button\" name=\"inflight-button\" data-ng-click=\"vm.inflightUrl()\">\n          <span class=\"track-bt-text\">{{ vm.configService.messages.redelivery.button_inflight_options }}</span>\n        </button>\n      </div>\n    </section>\n    <section class=\"c-export-details c-item-summary\">\n      <div class=\"picture-container\" id=\"picture-blob-holder\" data-ng-if=\"vm.signatureImage\" data-ng-init=\"vm.renderSignature()\">\n      </div>\n      <div class=\"additional-info picture-description\">\n        <p data-ng-bind-html=\"vm.markdownToHTML(vm.trackingDetails.summary.statusHelpText)\"\n           data-ng-if=\"vm.trackingDetails.summary.statusHelpText\"></p>\n        <p data-ng-if=\"vm.trackingDetails.signature.recipientName\">\n          <span data-ng-bind=\"vm.configService.messages.pod_print.signed_for\"></span>\n          <span\n            class=\"signed-name\"\n            data-ng-bind=\"vm.trackingDetails.signature.recipientName\"></span>\n        </p>\n        <p class=\"delivery-time\" data-ng-if=\"vm.trackingDetails.signature.signatureDateTime\">\n          {{ vm.configService.messages.pod_print.delivery }} {{ vm.ignoreTimezone(vm.trackingDetails.signature.signatureDateTime) | date:'HH:mm' | formatTime }}\n        </p>\n        <button class=\"print-button\" name=\"print-button\" data-ng-click=\"vm.printPage()\" data-ng-if=\"vm.showButton(vm.hidePrintButton)\">\n          {{ vm.configService.messages.pod_print.button }}\n        </button>\n        <button class=\"rotate-button\" id=\"rotate-button\" title=\"{{ vm.configService.messages.pod_print.rotate_button }}\" data-ng-click=\"vm.rotateImage()\" data-ng-if=\"vm.showButton(vm.hideRotateButton)\">\n          <i class=\"icon-container rotate-image-button\"></i>\n        </button>\n      </div>\n      <div class=\"international-delivery\" data-ng-if=\"vm.trackingDetails.summary.internationalPostalProvider\">\n        <p data-ng-if=\"vm.trackingDetails.summary.internationalPostalProvider.title\">{{ vm.parcelflown.header }}</p>\n        <p data-ng-if=\"vm.trackingDetails.summary.internationalPostalProvider.title\" class=\"international-title\">\n          {{ vm.trackingDetails.summary.internationalPostalProvider.title }}</p>\n        <a data-ng-if=\"vm.trackingDetails.summary.internationalPostalProvider.url\" data-ng-href=\"{{ vm.trackingDetails.summary.internationalPostalProvider.url }}\"\n           class=\"continue-bt\" name=\"continue-bt\" target=\"_blank\">{{ vm.parcelflown.button }}</a>\n        <p data-ng-if=\"vm.trackingDetails.summary.internationalPostalProvider.description\">{{ vm.trackingDetails.summary.internationalPostalProvider.description }}</p>\n      </div>\n    </section>\n    <gps-map-component data-ng-if=\"vm.isGPSOptionEnabled()\"></gps-map-component>\n  </div>\n  <div class=\"m-tracking-history\" data-ng-if=\"vm.trackingDetails.events\">\n    <section class=\"c-tracking-history\">\n      <div class=\"limited-history\" data-ng-if=\"vm.isPFW()\">\n        <span data-ng-bind-html=\"vm.PFWLimitedHistory\"></span>\n        <a\n          data-ng-href=\"{{ vm.configService.links.limited_history_pfw }}{{ vm.trackingDetails.mailPieceId }}\"\n          data-ng-bind=\"vm.configService.messages.pfw.limited_history_text\"\n          target=\"_blank\"></a>\n      </div>\n      <div data-ng-repeat=\"(day, messages) in vm.trackingHistory\">\n        <div data-ng-show=\"vm.showExtendedHistory || messages.isFirstDay\">\n          <h4>\n            <span class=\"tracking-history-label\" data-ng-show=\"messages.isFirstDay\">{{ vm.trackingHistoryText.history_label }}</span>\n            <span class=\"tracking-history-day\">{{ vm.convertDate(day) }}</span>\n          </h4>\n          <ol>\n            <li data-ng-repeat=\"message in messages\" class=\"tracking-history-item\">\n              <time>{{ vm.ignoreTimezone(message.eventDateTime) | date:'hh:mma' | lowercase }}</time>\n              <div class=\"tracking-history-detail\">\n                <span class=\"message\"\n                      data-ng-bind-html=\"vm.markdownToHTML(message.eventName)\"></span>\n                <span class=\"location\">{{ message.locationName }}</span>\n              </div>\n            </li>\n          </ol>\n          <footer\n            data-ng-class=\"vm.getToggleClass(vm.showExtendedHistory)\"\n            data-ng-show=\"messages.isFirstDay && vm.showExtendedFooter\"\n            data-ng-click=\"vm.expandTrackingHistory()\">\n            <span class=\"icon\"></span>\n            <span class=\"see-history-link\">\n              {{ vm.showExtendedHistory ? vm.configService.messages.tracking_results.minimize : vm.configService.messages.tracking_results.maximize }}\n            </span>\n          </footer>\n        </div>\n      </div>\n    </section>\n  </div>\n  <div id=\"printView\" data-ng-show=\"false\">\n    <header>\n      <img src=\"{{ vm.configService.messages.pod_print.royal_mail_logo }}\" alt=\"{{ vm.configService.messages.pod_print.logo_alt_text }}\">\n      <h1>{{ vm.configService.messages.pod_print.header }}</h1>\n      <h2>{{ vm.configService.messages.pod_print.sub_header }}</h2>\n      <p>{{ vm.configService.messages.tracking_results.tracking_code_text }} {{ vm.trackingDetails.mailPieceId }}</p>\n    </header>\n    <section class=\"c-item-summary\" >\n      <div class=\"picture-container\" style=\"max-width: 250px; padding: 15px;\" data-ng-if=\"vm.isImageRendered()\">\n        <img id=\"print-image\" data-ng-src=\"{{ vm.imageSrc }}\" data-ng-style=\"vm.rotationStyle\"></img>\n      </div>\n      <div class=\"picture-description\">\n        <p>{{ vm.trackingDetails.summary.summaryLine }}</p>\n        <p data-ng-if=\"vm.trackingDetails.signature\">{{ vm.configService.messages.pod_print.signed_for }} <span class=\"signed-name\">{{ vm.trackingDetails.signature.recipientName }}</span></p>\n        <p>{{ vm.configService.messages.pod_print.product_name }} {{ vm.trackingDetails.summary.productName }}</p>\n        <p data-ng-if=\"vm.trackingDetails.signature.signatureDateTime\">{{ vm.configService.messages.pod_print.delivery }} {{ vm.ignoreTimezone(vm.trackingDetails.signature.signatureDateTime) | date:'HH:mm' | formatTime }}</p>\n      </div>\n    </section>\n  </div>\n</div>\n"

/***/ }),
/* 34 */
27,
/* 35 */,
/* 36 */,
/* 37 */
27,
/* 38 */,
/* 39 */
27,
/* 40 */,
/* 41 */
27,
/* 42 */,
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _overlayTemplate = __webpack_require__(44);
	
	var _overlayTemplate2 = _interopRequireDefault(_overlayTemplate);
	
	var _overlayTemplateView = __webpack_require__(45);
	
	var _overlayTemplateView2 = _interopRequireDefault(_overlayTemplateView);
	
	__webpack_require__(46);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var overlayComponent = {
	
	  template: _overlayTemplateView2.default,
	  controller: _overlayTemplate2.default,
	  controllerAs: 'vm'
	
	};
	
	exports.default = overlayComponent;

/***/ }),
/* 44 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function overlayController(overlayService, configService) {
	
	  var vm = this;
	  vm.overlayGetter = overlayService.getOverlayState();
	  vm.overlayToggle = overlayService.toggleOverlay;
	  vm.overlayText = configService.messages.reference_help;
	  vm.overlayButton = configService.messages.button;
	
	  // Here to avoid loosing state when returning to the trackingcode page
	  angular.element(document).ready(function () {
	
	    var overlay = document.getElementById('overlay');
	    angular.element(document.body).append(overlay);
	  });
	}
	
	exports.default = overlayController;

/***/ }),
/* 45 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"overlay-backdrop\"></div>\n\n<div class=\"m-overlay\">\n\n    <div class=\"holder\">\n\n        <div class=\"outer-close-button-holder\">\n            <span class=\"outer-close-button\" ng-click=\"vm.overlayToggle()\"><i class=\"white-close-button\"></i></span>\n        </div>\n\n        <div class=\"inner-holder\">\n            <header class=\"heading-container\">\n                <span class=\"heading\"> {{ vm.overlayText.header }} </span>\n                <span class=\"inner-close-button\" ng-click=\"vm.overlayToggle()\">{{ vm.overlayButton.close }}\n                    <i class=\"grey-close-button\"></i>\n                </span>\n            </header>\n\n            <div class=\"c-overlay\">\n                <p class=\"main-text\" ng-bind-html=\"vm.overlayText.body\"></p>\n\n                <div>\n                    <div class=\"left-img-section\">\n                        <img class=\"left-img\" src=\"http://placehold.it/300x500\" alt=\"example reference card\">\n                    </div>\n\n                    <div class=\"or-separator\">{{ vm.overlayText.or }}</div>\n\n                    <div class=\"right-img-section\">\n                        <img class=\"right-img\" src=\"http://placehold.it/300x500\" alt=\"another example reference card\">\n                    </div>\n                </div>\n\n            </div>\n\n            <footer class=\"footer\">\n                <p ng-bind-html=\"vm.overlayText.overlay_footer_header\"></p>\n                <p class='footer-line-one' ng-bind-html=\"vm.overlayText.footer_line_one\"></p>\n                <a class='footer-line-one-mob' ng-bind-html=\"vm.overlayText.footer_line_one_mob\"></a>\n            </footer>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 46 */
27,
/* 47 */,
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _recentlyTracked = __webpack_require__(49);
	
	var _recentlyTracked2 = _interopRequireDefault(_recentlyTracked);
	
	var _recentlyTrackedView = __webpack_require__(50);
	
	var _recentlyTrackedView2 = _interopRequireDefault(_recentlyTrackedView);
	
	__webpack_require__(51);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var recentlyTrackedComponent = {
	  template: _recentlyTrackedView2.default,
	  controller: _recentlyTracked2.default,
	  controllerAs: 'vm'
	};
	
	exports.default = recentlyTrackedComponent;

/***/ }),
/* 49 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * @description: fetch most recently tracked items from server.
	 * @requires {Object} configService
	 * @requires {Object} parcelsService
	 * @requires {Object} applicationModel
	 * @requires {Object} numberService
	 * @requires {Object} $location
	 * @requires {Object} $cookies
	 * @requires {Function} $timeout
	 * @requires {Object} $window
	 */
	function recentlyTrackedController(configService, parcelsService, numberService, applicationModel, $location, $cookies, $timeout, $window) {
	
	  var vm = this;
	
	  function handleResponseError(rejection) {
	
	    // No error message from API, use CMS defined.
	    if ((typeof rejection === 'undefined' ? 'undefined' : _typeof(rejection)) !== 'object' || !Array.isArray(rejection)) {
	
	      vm.rtiError = configService.messages.recently_tracked.error;
	    } else {
	
	      vm.rtiListError = rejection;
	    }
	  }
	
	  function init() {
	
	    // Checks the parcels_jwt cookie was found and is valid.
	    if (parcelsService.isValidCookie()) {
	
	      // Set authToken as the parcels_jwt cookie was found and is valid.
	      applicationModel.authToken = $cookies.get('parcels_jwt');
	
	      var JWT = parcelsService.decodeJWT(applicationModel.authToken);
	      var guid = parcelsService.isSet(JWT, 'sub') !== '' ? parcelsService.isSet(JWT, 'sub') : 0;
	
	      // API call as we have a valid auth token.
	      parcelsService.getRtiResults(guid, configService.api.app_id, configService.api.recently_tracked_max_items).then(function (response) {
	
	        vm.recentlyTrackedItems = parcelsService.isSet(response.data, 'mailPieces');
	      }, function (rejection) {
	
	        handleResponseError(rejection);
	      });
	    } else {
	
	      // Resetting to default values as parcels_jwt cookie wasn't found or it is invalid.
	      vm.loggedIn = false;
	      applicationModel.authToken = null;
	      handleResponseError('');
	    }
	  }
	
	  /**
	   * Reset variables.
	   */
	  function reset() {
	
	    vm.recentlyTrackedItems.length = 0;
	    delete vm.rtiListError;
	    delete vm.rtiError;
	  }
	
	  function refresh() {
	
	    // Reset variables to avoid wrong old data.
	    reset();
	    init();
	  }
	
	  function followLink(link) {
	
	    $location.url('/tracking-results/' + link);
	  }
	
	  function isResultsPage() {
	
	    return window.location.hash.indexOf('tracking-results') > -1;
	  }
	
	  function trackingNumber() {
	
	    return applicationModel.sanitizedNumber;
	  }
	
	  function renderTrackingNumber(code) {
	
	    return numberService.filterNumber(code);
	  }
	
	  vm.recentlyTrackedItems = [];
	  vm.loggedIn = parcelsService.isValidCookie;
	  vm.details = configService.messages.recently_tracked.details_button;
	  vm.refresh = configService.messages.recently_tracked.refresh_button;
	  vm.redelivery = configService.messages.recently_tracked.redelivery_button;
	  vm.saveItems = configService.messages.recently_tracked.save_items;
	  vm.login = configService.messages.recently_tracked.login;
	  vm.login_default = configService.messages.recently_tracked.login_default;
	  vm.rtiLinkText = configService.messages.recently_tracked.link_text;
	  vm.rtiLink = configService.links.rti_full_page;
	  vm.manualRefresh = refresh;
	  vm.followLink = followLink;
	  vm.init = init;
	  vm.configService = configService;
	  vm.isResultsPage = isResultsPage;
	  vm.trackingNumber = trackingNumber;
	  vm.renderTrackingNumber = renderTrackingNumber;
	  vm.markdownToHTML = parcelsService.markdownToHTML;
	
	  if (vm.loggedIn) init();
	
	  // Use timeout 0 here to wait until the DOM is fully loaded.
	  $timeout(function () {
	
	    // Make triggerRTIWidgetReload available in the window object to share with Drupal.
	    $window.triggerRTIWidgetReload = refresh;
	  });
	}
	
	exports.default = recentlyTrackedController;

/***/ }),
/* 50 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"c-recently-tracked\">\n  <div data-ng-if=\"vm.loggedIn && vm.recentlyTrackedItems.length == 0 && !vm.rtiListError && !vm.rtiError\">\n    <article class=\"status-bar-problem-lost\">\n      <p>{{ vm.saveItems }}</p>\n    </article>\n    <button\n      class=\"refresh-button\"\n      data-ng-click=\"vm.manualRefresh()\">\n      <span class=\"icon-container icon-refresh\"></span>\n      <span class=\"button-text\">{{ vm.refresh }}</span>\n    </button>\n  </div>\n  <div class=\"rti-list\" data-ng-if=\"vm.loggedIn && vm.recentlyTrackedItems.length > 0\">\n    <article class=\"rti-alert-information\">\n      <div class=\"rti-alert-information-icon\">\n        <i class=\"icon-information\"></i>\n      </div>\n      <div class=\"rti-alert-information-text\">\n        {{ vm.configService.messages.recently_tracked.limit_information }}\n      </div>\n    </article>\n    <button\n      class=\"refresh-button\"\n      data-ng-click=\"vm.manualRefresh()\">\n      <span class=\"icon-container icon-refresh\"></span>\n      <span class=\"button-text\">{{ vm.refresh }}</span>\n    </button>\n\n    <article\n      class=\"recently-tracked-card\"\n      data-ng-click=\"vm.followLink(item.mailPieceId)\"\n      data-ng-repeat=\"item in vm.recentlyTrackedItems track by $index\">\n      <div class=\"status-icon\">\n        <i data-ng-if=\"!item.error\" data-ng-class=\"item.summary.statusCategory | statusCategoryFilter\"></i>\n        <i data-ng-if=\"item.error\" class=\"icon_status_no-status\"></i>\n      </div>\n      <div class=\"data-card\">\n        <p\n          data-ng-if=\"item.summary.statusCategory\"\n          class=\"tracking-item-status\"\n          data-ng-bind-html=\"vm.markdownToHTML(item.summary.statusDescription)\">\n        </p>\n        <p\n          data-ng-if=\"item.error\"\n          class=\"tracking-item-status\">\n          {{ vm.configService.messages.card_error_title }}\n        </p>\n        <p class=\"tracking-code\">{{ vm.renderTrackingNumber(item.mailPieceId) }}</p>\n        <p\n          data-ng-if=\"item.summary.summaryLine\"\n          class=\"tracking-item-summary-line\"\n          data-ng-bind-html=\"vm.markdownToHTML(item.summary.summaryLine)\">\n        </p>\n        <p\n          data-ng-if=\"item.error.errorDescription\"\n          class=\"tracking-item-error-description\">\n          {{ item.error.errorDescription }}\n        </p>\n\n        <a\n          class=\"redelivery-button\"\n          data-ng-if=\"item.links.redelivery.title\"\n          data-ng-href=\"{{ item.links.redelivery.href }}\">\n          {{ vm.redelivery }}\n        </a>\n        <a\n          class=\"tracking-details\"\n          data-ng-if=\"!item.links.redelivery.title && !item.error\"\n          data-ng-href=\"#/tracking-results/{{ item.mailPieceId }}\">\n          {{ vm.details }}\n        </a>\n      </div>\n    </article>\n  </div>\n\n  <div data-ng-if=\"vm.rtiListError\">\n    <button\n      class=\"refresh-button\"\n      data-ng-click=\"vm.manualRefresh()\">\n      <span class=\"icon-container icon-refresh\"></span>\n      <span class=\"button-text\">{{ vm.refresh }}</span>\n    </button>\n    <article class=\"status-bar-problem-lost\">\n      <h5 data-ng-if=\"vm.rtiListError\"\n          data-ng-repeat=\"error in vm.rtiListError\"\n          class=\"c-error\">\n        <i class=\"icon-information-red\"></i>\n        {{ error.errorDescription }}\n      </h5>\n    </article>\n  </div>\n\n  <div data-ng-if=\"vm.loggedIn && vm.rtiError\">\n    <button\n      class=\"refresh-button\"\n      data-ng-click=\"vm.manualRefresh()\">\n      <span class=\"icon-container icon-refresh\"></span>\n      <span class=\"button-text\">{{ vm.refresh }}</span>\n    </button>\n    <article class=\"status-bar-problem-lost\">\n      <h5 class=\"c-error\">\n        <i class=\"icon-information-red\"></i>\n        {{ vm.rtiError }}\n      </h5>\n    </article>\n  </div>\n\n  <p\n    class=\"logged-out-message\"\n    data-ng-if=\"!vm.loggedIn && vm.isResultsPage()\"\n    data-ng-bind-html=\"vm.login\">\n  </p>\n  <p\n    class=\"logged-out-message\"\n    data-ng-if=\"!vm.loggedIn && !vm.isResultsPage()\"\n    data-ng-bind-html=\"vm.login_default\">\n  </p>\n  <a\n    id=\"save-item-bt\"\n    class=\"rti-hide\"\n    name=\"save-item-bt\"\n    data-tracking-number=\"{{ vm.trackingNumber() }}\"\n    data-ng-show=\"!vm.loggedIn && vm.isResultsPage()\"\n    href=\"user/login\">\n    <span class=\"save-item-bt-text\">{{ vm.configService.messages.recently_tracked.save_item_button }}</span>\n  </a>\n  <p\n    data-ng-if=\"vm.loggedIn && vm.recentlyTrackedItems.length > 0\"\n    class=\"rti-shown-information\" >\n    {{ vm.configService.messages.recently_tracked.shown_amount_before_no }}\n    {{ vm.recentlyTrackedItems.length }}\n    {{ vm.configService.messages.recently_tracked.shown_amount_after_no }}\n  </p>\n  <a\n    data-ng-if=\"vm.loggedIn && vm.recentlyTrackedItems.length > 0\"\n    data-ng-href=\"{{ vm.rtiLink }}\"\n    class=\"rti-page-link\">\n    {{ vm.rtiLinkText }}\n  </a>\n</div>\n"

/***/ }),
/* 51 */
27,
/* 52 */,
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _googleRecaptcha = __webpack_require__(54);
	
	var _googleRecaptcha2 = _interopRequireDefault(_googleRecaptcha);
	
	var _googleRecaptchaView = __webpack_require__(55);
	
	var _googleRecaptchaView2 = _interopRequireDefault(_googleRecaptchaView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var googleRecaptchaComponent = {
	  template: _googleRecaptchaView2.default,
	  bindings: {
	    recaptchaId: '<',
	    recaptchaSize: '<'
	  },
	  controller: _googleRecaptcha2.default,
	  controllerAs: 'vm'
	};
	
	exports.default = googleRecaptchaComponent;

/***/ }),
/* 54 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * @description: Google Recaptcha Controller.
	 */
	function googleRecaptchaController() {}
	
	exports.default = googleRecaptchaController;

/***/ }),
/* 55 */
/***/ (function(module, exports) {

	module.exports = "<div data-ng-attr-id=\"{{ vm.recaptchaId }}\" data-ng-attr-data-size=\"{{ vm.recaptchaSize }}\"></div>"

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _pfwOverlay = __webpack_require__(57);
	
	var _pfwOverlay2 = _interopRequireDefault(_pfwOverlay);
	
	var _pfwOverlayView = __webpack_require__(58);
	
	var _pfwOverlayView2 = _interopRequireDefault(_pfwOverlayView);
	
	__webpack_require__(59);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pfwOverlayComponent = {
	
	  template: _pfwOverlayView2.default,
	  controller: _pfwOverlay2.default,
	  controllerAs: 'vm'
	
	};
	
	exports.default = pfwOverlayComponent;

/***/ }),
/* 57 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * @description: Parcelforce overlay.
	 * @requires {Object} configService
	 * @requires {Object} overlayService
	 * @requires {Object} $rootScope
	 */
	function pfwOverlayController(overlayService, configService, $rootScope) {
	
	  var vm = this;
	  vm.pfwTrackingNumber = overlayService.getPfwTrackingNumber;
	  vm.overlayGetter = overlayService.getPfwOverlayState();
	  vm.overlayHeading = configService.messages.pfw.overlay_heading;
	  vm.overlayText = configService.messages.pfw.overlay_text;
	  vm.overlayButton = configService.messages.button.close;
	  vm.pfwLink = configService.links.limited_history_pfw;
	  vm.pfwWebsite = configService.messages.pfw.overlay_website;
	  vm.overlayToggle = function () {
	
	    overlayService.togglePfwOverlay();
	    $rootScope.$broadcast('overlayClosed');
	  };
	
	  // Here to avoid loosing state when returning to the trackingcode page
	  angular.element(document).ready(function () {
	
	    var overlay = document.getElementById('overlay');
	    angular.element(document.body).append(overlay);
	  });
	}
	
	exports.default = pfwOverlayController;

/***/ }),
/* 58 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"overlay-backdrop\"></div>\n\n<div class=\"m-overlay\">\n\n\t<div class=\"c-overlay\">\n\t\t<div class=\"holder\">\n\t\t\t<div class=\"inner-holder\">\n\t\t\t\t<div class=\"button-holder\" data-ng-click=\"vm.overlayToggle()\">\n\t\t\t\t\t{{ vm.overlayButton }}\n\t\t\t\t\t<i class=\"grey-close-button\"></i>\n\t\t\t\t</div>\n\t\t\t\t<h4>{{ vm.overlayHeading }}</h4>\n\t\t\t\t<p>{{ vm.overlayText }} <a data-ng-href=\"{{ vm.pfwLink }}{{ vm.pfwTrackingNumber() }}\" target=\"_blank\">{{ vm.pfwWebsite }}</a></p>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n</div>"

/***/ }),
/* 59 */
27,
/* 60 */,
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _gpsMap = __webpack_require__(62);
	
	var _gpsMap2 = _interopRequireDefault(_gpsMap);
	
	var _gpsMapView = __webpack_require__(63);
	
	var _gpsMapView2 = _interopRequireDefault(_gpsMapView);
	
	__webpack_require__(64);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var gpsMapComponent = {
	  template: _gpsMapView2.default,
	  controller: _gpsMap2.default,
	  controllerAs: 'vm'
	};
	
	exports.default = gpsMapComponent;

/***/ }),
/* 62 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Controller for GPS map
	 * @requires {Object} applicationModel
	 * @requires {Object} configService
	 * @requires {Object} eventTypeService
	 * @requires {Object} $scope
	 * @requires {Function} $timeout
	 */
	
	function gpsMapController(applicationModel, configService, eventTypeService, tealiumService, $scope, $timeout) {
	
	  var vm = this;
	  // Map variables
	  var defaultPin = void 0;
	  var map = void 0;
	  var infobox = void 0;
	
	  /**
	   * Gets the GPS toggle class
	   * @param {Boolean} state
	   * @returns {String}
	   */
	  function getGPSToggleClass(state) {
	
	    return state ? 'expanded' : 'collapsed';
	  }
	
	  /**
	   * Set Map focus
	   */
	  function setMapFocus() {
	
	    var mapElement = document.getElementById('gps-container');
	    mapElement.scrollIntoView({ block: 'center' });
	    mapElement.focus();
	  }
	
	  /**
	   * Wait to load map.
	   */
	  function waitToLoadMap() {
	
	    if (document.getElementById('gps-container').children.length !== 0) {
	
	      vm.showExtendedGPS = !vm.showExtendedGPS;
	      vm.showSpinner = false;
	      $scope.$apply();
	      setMapFocus();
	    } else {
	
	      $timeout(waitToLoadMap);
	    }
	  }
	
	  window.bingmapsCallback = function () {
	
	    if (window.Microsoft) {
	
	      vm.showMapError = false;
	      var mapElement = document.getElementById('gps-container');
	      var mapPosition = applicationModel.trackingDetails.mailPieces.position;
	      var latlong = '<span class="coordinates">' + configService.messages.gps.coordinates + '</span><br>\n        <span class="latlong">' + mapPosition.latitude + ', ' + mapPosition.longitude + '</span>';
	      // eslint-disable-next-line no-undef
	      var mapCenter = new Microsoft.Maps.Location(mapPosition.latitude, mapPosition.longitude);
	      // eslint-disable-next-line no-undef
	      defaultPin = new Microsoft.Maps.Pushpin(mapCenter, {
	        icon: "<svg width='43px' height='64px' viewBox='0 0 43 64' version='1.1' xmlns='http://www.w3.org/2000/svg'><g id='01-Atoms-/-09-Map-/-Pin-/-Generic-/-Default' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'><path d='M21.4951804,2 C10.7279286,2 2,10.7960267 2,21.6430772 C2,25.625419 3.51452481,29.4041664 4.28067417,30.8547756 C9.42294895,42.3408859 21.4951804,61.1724138 21.4951804,61.1724138 C21.4951804,61.1724138 33.5674118,42.3399434 38.710622,30.8519479 C39.4749004,29.405109 40.8687497,25.625419 40.9912962,21.6421347 C41.3205814,10.8016821 32.2614966,2 21.4951804,2 Z' id='Shape' stroke='#EBECE2' stroke-width='2' fill='{color}'></path></g></svg>",
	        color: '#DA202A'
	      });
	      // eslint-disable-next-line no-undef
	      map = new Microsoft.Maps.Map(mapElement, {
	        credentials: vm.configService.bingMapConfig.key,
	        showMapTypeSelector: false,
	        showLocateMeButton: false,
	        showDashboard: true,
	        enableSearchLogo: true,
	        showBreadcrumb: true,
	        center: mapCenter,
	        minZoom: vm.configService.bingMapConfig.minZoom,
	        disableZooming: true,
	        disablePanning: true
	      });
	      // eslint-disable-next-line no-undef
	      infobox = new Microsoft.Maps.Infobox(defaultPin.getLocation(), {
	        description: latlong,
	        offset: new Microsoft.Maps.Point(-10, 90) // eslint-disable-line no-undef
	        // Adjusting the tooltip\infobox positions(left, top) to show above the pushpin.
	      });
	      // eslint-disable-next-line no-undef
	      Microsoft.Maps.Events.addHandler(defaultPin, 'click', function () {
	
	        infobox.setOptions({ visible: true });
	      });
	      map.entities.push(defaultPin);
	      infobox.setMap(map);
	      waitToLoadMap();
	    }
	  };
	
	  /**
	   * Loads the Bingmap script
	   * @param {String} url
	   * @param {String} Key
	   */
	  function loadBingMapScript(url, Key) {
	
	    var script = document.createElement('script');
	    script.type = 'text/javascript';
	    script.async = true;
	    script.defer = true;
	    script.src = url + '?key=' + Key + '&callback=bingmapsCallback';
	    document.head.appendChild(script);
	    script.onerror = function () {
	
	      vm.showMapError = true;
	      vm.showSpinner = false;
	      $scope.$apply();
	    };
	  }
	
	  /**
	   * Toggles the GPS Map.
	   */
	  function toggleMap() {
	
	    var mapElement = document.getElementById('gps-container');
	    if (!vm.showExtendedGPS && mapElement.children.length === 0) {
	
	      vm.showSpinner = true;
	      var key = vm.configService.bingMapConfig.key;
	      var url = vm.configService.bingMapConfig.url;
	      loadBingMapScript(url, key);
	
	      var tags = {};
	      tags.mapView = {
	        eventName: 'map_view',
	        link_name: 'view_on_map'
	      };
	      tealiumService.sendTags(tags.mapView, 'link');
	    } else {
	
	      vm.showExtendedGPS = !vm.showExtendedGPS;
	    }
	
	    // Set the focus on the map when the map is displayed
	    $timeout(setMapFocus);
	  }
	
	  /**
	   * Handle key enter event for toggling map display.
	   * @param {Event} event
	   */
	  function toggleMapWithEnter(event) {
	
	    if (event.keyCode === 13) {
	
	      event.preventDefault();
	      toggleMap();
	    }
	  }
	
	  /**
	   * Get the text to display for the GPS Map link.
	   * @returns {String} The message to display.
	   */
	  function getMapLinkText() {
	
	    if (vm.showExtendedGPS) {
	
	      return vm.configService.messages.gps.close_map_link_text;
	    }
	
	    return vm.configService.messages.gps.show_on_map_link_text;
	  }
	
	  /**
	   * Gets the information text based on Event Code.
	   */
	  function getInformationText() {
	
	    return eventTypeService.getEventTypeText(applicationModel.trackingDetails.mailPieces.events);
	  }
	
	  vm.configService = configService;
	  vm.getGPSToggleClass = getGPSToggleClass;
	  vm.toggleMap = toggleMap;
	  vm.toggleMapWithEnter = toggleMapWithEnter;
	  vm.getMapLinkText = getMapLinkText;
	  vm.showExtendedGPS = false;
	  vm.showMapError = false;
	  vm.getInformationText = getInformationText;
	  vm.showSpinner = false;
	}
	
	exports.default = gpsMapController;

/***/ }),
/* 63 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"gps-section\" data-ng-class=\"vm.getGPSToggleClass(vm.showExtendedGPS)\">\n  <a\n    href=\"javascript:void(0);\"\n    class=\"gps-link-section\"\n    data-ng-click=\"vm.toggleMap()\"\n    data-ng-keypress=\"vm.toggleMapWithEnter($event)\"\n    data-ng-class=\"vm.getGPSToggleClass(vm.showExtendedGPS)\"\n  >\n    <span class=\"icon\"></span>\n    <span class=\"link-text\">\n      {{ vm.getMapLinkText() }}\n    </span>\n  </a>\n  <div class=\"map-error\" data-ng-if=\"vm.showMapError\">{{ vm.configService.messages.gps.map_error }}</div>\n  <div class=\"spinner-wrap\" data-ng-if=\"vm.showSpinner\">\n    <div class=\"spinner\"></div>\n  </div>\n  <div class=\"map-content\" data-ng-show=\"vm.showExtendedGPS\">\n    <div class=\"info-container\">\n      <div class=\"info-icon-section\"><span class=\"info-icon\"></span></div>\n      <div class=\"info-text\">{{ vm.getInformationText() }}</div>\n    </div>\n    <div class=\"map\">\n      <div id=\"gps-container\" tabindex=\"0\"></div>\n    </div>\n  </div>\n</section>"

/***/ }),
/* 64 */
27,
/* 65 */,
/* 66 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * @description: Application Model.
	 * @requires {Object} $cookies
	 */
	function applicationModel($cookies) {
	
	  /* @ngInject */
	  var trackingDetails = {};
	  var estimatedDelivery = {};
	
	  /**
	   * @description: Checks the cookie and sets the sessionToken in the application model.
	   */
	  function checkSessionToken() {
	
	    // TODO remove the x-recaptcha-session once APIm deploys 3.2.
	    var sessionCookie = $cookies.get('X-RMG-API-Session') || $cookies.get('x-recaptcha-session');
	
	    if (sessionCookie !== undefined && sessionCookie !== null && sessionCookie !== 'null') {
	
	      return sessionCookie;
	    }
	
	    return null;
	  }
	
	  return {
	    trackingDetails: trackingDetails,
	    estimatedDelivery: estimatedDelivery,
	    urlRefresh: true,
	    urlRequest: {},
	    googleRecaptcha: {
	      sessionToken: checkSessionToken()
	    },
	    authToken: null
	  };
	}
	
	exports.default = applicationModel;

/***/ }),
/* 67 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function parcelsConfigService() {
	
	  var options = {};
	
	  this.config = function (opt) {
	
	    angular.merge(options, opt);
	  };
	
	  this.$get = [function () {
	
	    if (!options) {
	
	      throw new Error('Config options must be configured');
	    }
	
	    return options;
	  }];
	}
	
	exports.default = parcelsConfigService;

/***/ }),
/* 68 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * @description : Handles overlay display.
	**/
	function overlayService() {
	
	  var overlayVisibility = false;
	  var pfwOverlayVisibility = false;
	  var pfwTrackingNumber = void 0;
	
	  return {
	
	    toggleOverlay: function toggleOverlay() {
	
	      overlayVisibility = !overlayVisibility;
	    },
	
	    togglePfwOverlay: function togglePfwOverlay() {
	
	      pfwOverlayVisibility = !pfwOverlayVisibility;
	    },
	
	    setPfwTrackingNumber: function setPfwTrackingNumber(trackingNumber) {
	
	      pfwTrackingNumber = trackingNumber;
	    },
	    getPfwTrackingNumber: function getPfwTrackingNumber() {
	      return pfwTrackingNumber;
	    },
	    getOverlayState: function getOverlayState() {
	      return overlayVisibility;
	    },
	    getPfwOverlayState: function getPfwOverlayState() {
	      return pfwOverlayVisibility;
	    }
	
	  };
	}
	
	exports.default = overlayService;

/***/ }),
/* 69 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * @description : Handle all tracking requests.
	 *
	 * @requires  {Object} trackingService
	 * @requires  {Object} numberService
	 * @requires  {Object} applicationModel
	 * @requires  {Object} trackingCodeService
	 * @requires  {Object} parcelsService
	 * @requires  {Object} notificationService
	 * @requires  {Function} $location
	 * @requires  {Object} $rootScope
	 * @requires  {Object} $cookies
	 * @requires  {Object} $q
	 * @returns   {Object} routeObject - object containing functions to resolve routes.
	 */
	function routeService(trackingService, numberService, applicationModel, trackingCodeService, parcelsService, notificationService, $location, $rootScope, $cookies, $q) {
	
	  /**
	   * Handle the possible errors in a valid response or rejection.
	   *
	   * @param {Object} response
	   * @param {String} trackingNumber
	   */
	  function handleErrors(response, trackingNumber) {
	
	    if (response[0]) {
	
	      applicationModel.urlRequest.error = response[0];
	      applicationModel.urlRequest.number = trackingNumber;
	      $location.path('/');
	    }
	
	    if (response.data && response.data.errors) {
	
	      for (var i = 0; response.data.errors.length; i++) {
	
	        if (response.data.errors[i].errorDescription !== '') {
	
	          applicationModel.urlRequest.error = response.data.errors[i].errorDescription;
	          break;
	        }
	      }
	
	      applicationModel.urlRequest.number = trackingNumber;
	      $location.path('/');
	    }
	
	    if (response.error) {
	
	      applicationModel.urlRequest.error = response.error;
	      applicationModel.urlRequest.number = trackingNumber;
	      $location.path('/');
	    }
	  }
	
	  var routeObject = {
	
	    /**
	     * Check the model isn't empty if it is redirect to home page.
	     */
	    checkModel: function checkModel() {
	
	      if (Object.keys(applicationModel.trackingDetails).length === 0) {
	
	        $location.path('/');
	      }
	    },
	
	    /**
	     * @description : Call tracking service with tracking number from URL.
	     * @param {String} trackingNumber
	     * @return {Promise}
	     */
	    resolveURL: function resolveURL(trackingNumber) {
	
	      var deferred = $q.defer();
	      var sanitizedTrackingNumber = numberService.sanitize(trackingNumber);
	      var isValidNumber = numberService.validate(sanitizedTrackingNumber);
	      var googleRecaptchaCheckRequired = trackingCodeService.triggerGoogleRecaptchaCheck();
	      var isMissMatch = true;
	      applicationModel.urlSearch = true;
	
	      if (angular.isDefined(applicationModel.trackingDetails.mailPieces) && applicationModel.trackingDetails.mailPieces.mailPieceId === trackingNumber) {
	
	        isMissMatch = false;
	      }
	
	      if (isValidNumber === true) {
	
	        if (googleRecaptchaCheckRequired && !applicationModel.macSessionHeader) {
	
	          // Redirect to the landing page, which will trigger captcha to init.
	          $location.path('/');
	          applicationModel.stopUrlRequest = false;
	
	          // Emit when the google recaptcha widget is available.
	          $rootScope.$on('googleRecaptchaWidgetAvailable', function () {
	
	            $rootScope.$emit('externalReSubmit', sanitizedTrackingNumber);
	          });
	        } else if (isMissMatch || applicationModel.macSessionHeader) {
	
	          deferred.resolve(routeObject.sendRequest(sanitizedTrackingNumber));
	
	          // This is to ensure we don't send a request if we already have the tracking information.
	        } else if (angular.isDefined(applicationModel.trackingDetails.mailPieces)) {
	
	          deferred.resolve();
	        }
	
	        // Send to Landing page.
	      } else if (isValidNumber === 'checkPFW') {
	
	        applicationModel.urlRequest.number = sanitizedTrackingNumber;
	        $location.path('/');
	        $rootScope.$emit('externalReSubmit', sanitizedTrackingNumber);
	      } else {
	
	        applicationModel.urlRequest.number = sanitizedTrackingNumber;
	        applicationModel.urlRequest.error = numberService.errorMessageMap(isValidNumber);
	
	        // Redirect to the landing page to handle the errors.
	        $location.path('/');
	      }
	
	      return deferred.promise;
	    },
	
	    sendRequest: function sendRequest(trackingNumber) {
	      return trackingService.getEvents(trackingNumber).then(function (response) {
	
	        handleErrors(response, trackingNumber);
	
	        if (response.data) {
	
	          applicationModel.trackingDetails = response.data;
	          applicationModel.estimatedDelivery = response.data.mailPieces.estimatedDelivery;
	        }
	      }).catch(function (rejection) {
	
	        handleErrors(rejection, trackingNumber);
	      });
	    },
	
	    /**
	     * @description : Check if the current request is a MAC URL request and redirect to normal request.
	     * @param  {Object} $route
	     * @returns {Function} handleRequest after setting MAC header if needed.
	     */
	    handleNotification: function handleNotification($route) {
	
	      var urlMac = angular.copy($route.current.params.mac);
	      var macHeader = '';
	
	      applicationModel.sanitizedNumber = angular.copy($route.current.params.number);
	
	      // Check if there is an existing valid session.
	      if (applicationModel.googleRecaptcha.sessionToken) {
	
	        var sessionExp = parcelsService.decodeJWT(applicationModel.googleRecaptcha.sessionToken).exp;
	
	        if (notificationService.isNewSessionNeeded(sessionExp)) {
	
	          // Set the MAC as header for an invalid session.
	          macHeader = notificationService.decodeMAC(urlMac);
	        }
	      } else {
	
	        // Set the MAC as header for an invalid session.
	        macHeader = notificationService.decodeMAC(urlMac);
	      }
	
	      // Reset macSessionHeader.
	      delete applicationModel.macSessionHeader;
	
	      if (macHeader !== '') {
	
	        // Add the session token to the ApplicationModel for future use.
	        applicationModel.macSessionHeader = macHeader;
	      }
	
	      return routeObject.handleRequest($route);
	    },
	
	    /**
	     * @description : Check if the current request is a URL request and check model isn't empty
	     * @param  {Object} $route
	     * @returns {Function} Tracking request if number is set in URL.
	     */
	    handleRequest: function handleRequest($route) {
	
	      routeObject.resetErrors();
	
	      applicationModel.sanitizedNumber = angular.copy($route.current.params.number);
	
	      // Set authToken if the parcels_jwt cookie was found and is valid.
	      applicationModel.authToken = parcelsService.isValidCookie() ? $cookies.get('parcels_jwt') : null;
	
	      if (applicationModel.sanitizedNumber) {
	
	        return routeObject.resolveURL(applicationModel.sanitizedNumber);
	      }
	
	      return routeObject.checkModel();
	    },
	
	    /**
	     * @description : Empties application model so that next request is clean.
	     */
	    resetErrors: function resetErrors() {
	
	      applicationModel.urlRequest = {};
	    }
	
	  };
	
	  return routeObject;
	}
	
	exports.default = routeService;

/***/ }),
/* 70 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function numberService(configService) {
	
	  // Character Minimun Length Value.
	  var TRACKING_NO_MIN_LENGTH = 9;
	  // Character Maxmimum Length Value.
	  var TRACKING_NO_MAX_LENGTH = 27;
	  // Allowed Alphanumeric Tracking Number Lengths.
	  var alphanumericFormatsLength = [9, 12, 13, 14];
	  // Allowed Hexadecimal Tracking Number Lengths.
	  var hexadecimalFormatsLength = [11, 16, 21];
	  // Concatenation of two arrays - Used to map against any invalid lengths.
	  var validStringLength = alphanumericFormatsLength.concat(hexadecimalFormatsLength);
	  // Length of Tracking Number.
	  var trackingNumberLength = void 0;
	
	  // A Hexadecimal map used for odd number increments and Hexadecimal map for Hex Check.
	  var alphabet = {
	    0: 0,
	    1: 1,
	    2: 2,
	    3: 3,
	    4: 4,
	    5: 5,
	    6: 6,
	    7: 7,
	    8: 8,
	    9: 9,
	    A: 10,
	    B: 11,
	    C: 12,
	    D: 13,
	    E: 14,
	    F: 15,
	    a: 10,
	    b: 11,
	    c: 12,
	    d: 13,
	    e: 14,
	    f: 15
	  };
	
	  var errorMap = {
	    INVALID_EMPTY: 'INVALID_EMPTY',
	    INVALID_LENGTH: 'INVALID_LENGTH',
	    INVALID_MIN_LENGTH: 'INVALID_MIN_LENGTH',
	    INVALID_MAX_LENGTH: 'INVALID_MAX_LENGTH',
	    INVALID_ALPHANUM: 'INVALID_ALPHANUM',
	    INVALID_CP: 'INVALID_CP',
	    INVALID_UID: 'INVALID_UID',
	    INVALID_NINE: 'INVALID_NINE',
	    INVALID_TWELVE: 'INVALID_TWELVE',
	    INVALID_THIRTEEN: 'INVALID_THIRTEEN',
	    INVALID_THIRTEEN_PFW: 'INVALID_THIRTEEN_PFW',
	    INVALID_FOURTEEN: 'INVALID_FOURTEEN'
	  };
	
	  /**
	   * @param {String} trackingNumber
	   * @returns {String}
	   */
	  function sanitize(trackingNumber) {
	
	    if (trackingNumber) {
	
	      return trackingNumber.replace(/[^0-9a-zA-Z]/g, '');
	    }
	
	    return trackingNumber;
	  }
	
	  /**
	   * @description : Calculates a Checksum.
	   * @param {String} trackingNumber
	   * @returns {String}
	   */
	  function checkSumCalculation(number) {
	
	    var numLength = number.length - 1;
	    var sum = 0;
	    var alternate = 0;
	    var currentCharacter = void 0;
	    var index = void 0;
	
	    // A Hexadecimal map with pre-calculated results for even numbers in the increment value.
	    // The values within the map are provided by RMG.
	    var doubleAlphabet = {
	      0: 0,
	      1: 2,
	      2: 4,
	      3: 6,
	      4: 8,
	      5: 5,
	      6: 6,
	      7: 7,
	      8: 1,
	      9: 3,
	      A: 5,
	      B: 7,
	      C: 9,
	      D: 13,
	      E: 14,
	      F: 15,
	      a: 5,
	      b: 7,
	      c: 9,
	      d: 13,
	      e: 14,
	      f: 15
	    };
	
	    for (index = numLength; index >= 0; index -= 1) {
	
	      currentCharacter = number.charAt(index);
	
	      alternate += 1;
	
	      if (alternate % 2 !== 0) {
	
	        currentCharacter = alphabet[currentCharacter];
	      } else {
	
	        currentCharacter = doubleAlphabet[currentCharacter];
	      }
	
	      sum += currentCharacter;
	    }
	
	    return sum % 16;
	  }
	
	  /**
	   * @description : Validates S10 UPU Standard Check.
	   * @param {String} trackingNumber
	   * @returns {Boolean}
	   */
	  function checkS10Calculation(trackingNumber) {
	
	    var weightArr = [8, 6, 4, 2, 3, 5, 9, 7];
	    var trackingNumberArr = trackingNumber.split('');
	    var sum = 0;
	    var i = 0;
	    var modSum = 0;
	    for (i = 2; i < 10; i++) {
	
	      sum += weightArr[i - 2] * trackingNumberArr[i];
	    }
	
	    modSum = 11 - sum % 11;
	
	    if (modSum === 10) {
	
	      modSum = 0;
	    } else if (modSum === 11) {
	
	      modSum = 5;
	    }
	
	    return parseInt(trackingNumberArr[10], 10) === modSum;
	  }
	
	  /**
	   * @description : Validates if a Hex Value is entered.
	   * @param {String} trackingNumber
	   * @returns {Boolean}
	   */
	  function isHexNumber(trackingNumber) {
	
	    for (var i = 0; i < trackingNumber.length; i++) {
	
	      if (isNaN(parseInt(trackingNumber.charAt(i), 16))) {
	
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  /**
	   * @description : Filter the number provided.
	   * @param {String} trackingNumber
	   * @returns {String} trackingNumber
	   */
	  function filterNumber(trackingNumber) {
	
	    return trackingNumber.replace(/\s/g, '');
	  }
	
	  /**
	   * Checking of passed value is number or not.
	   * @param {Number} value
	   * @returns {Boolean} true or false
	   */
	  function isNumber(value) {
	
	    return typeof value === 'number';
	  }
	
	  /**
	   * Checking of passed value is zero or not.
	   * @param {Number} value
	   * @returns {Boolean} true or false
	   */
	  function isValueZero(value) {
	
	    return value === 0;
	  }
	
	  /**
	   * Validates coordinates.
	   * @param {Number} latitude
	   * @param {Number} longitude
	   * @returns {Boolean} true or false
	   */
	  function areValidCoordinates(latitude, longitude) {
	
	    if (isNumber(latitude) && isNumber(longitude)) {
	
	      return !isValueZero(latitude) || !isValueZero(longitude);
	    }
	    return false;
	  }
	
	  return {
	
	    errorMap: errorMap,
	
	    checkSumCalculation: checkSumCalculation,
	
	    sanitize: sanitize,
	
	    isHexNumber: isHexNumber,
	
	    filterNumber: filterNumber,
	
	    validate: function validate(trackingNumber) {
	
	      // A number can't be blank.
	      if (!trackingNumber || trackingNumber.length === 0) {
	
	        return errorMap.INVALID_EMPTY;
	      }
	
	      // The tracking number has to be Alpha-Numeric
	      // and has to have a valid string length.
	      if (/[^0-9a-zA-Z]$/g.test(trackingNumber)) {
	
	        return errorMap.INVALID_ALPHANUM;
	      }
	
	      trackingNumberLength = trackingNumber.length;
	
	      // Check if invalid String length
	      if (validStringLength.indexOf(trackingNumberLength) === -1 && trackingNumberLength > TRACKING_NO_MIN_LENGTH && trackingNumberLength < TRACKING_NO_MAX_LENGTH) {
	
	        return errorMap.INVALID_LENGTH;
	      }
	
	      // Check if the tracking number is < 9.
	      if (trackingNumber.length < TRACKING_NO_MIN_LENGTH) {
	
	        return errorMap.INVALID_MIN_LENGTH;
	      }
	
	      // Check if the tracking number is > 27.
	      if (trackingNumber.length > TRACKING_NO_MAX_LENGTH) {
	
	        return errorMap.INVALID_MAX_LENGTH;
	      }
	
	      // Validate UID numbers.
	      if (hexadecimalFormatsLength.indexOf(trackingNumberLength) !== -1 && isHexNumber(trackingNumber)) {
	
	        if (checkSumCalculation(trackingNumber) === 0) {
	
	          return true;
	        }
	
	        return errorMap.INVALID_UID;
	      }
	
	      // This is always a Parcelforce number.
	      if (trackingNumberLength === 9) {
	
	        return 'checkPFW';
	      }
	
	      // This is always a Parcelforce number.
	      if (trackingNumberLength === 12) {
	
	        return 'checkPFW';
	      }
	
	      if (trackingNumberLength === 13) {
	
	        // Check if the number is in CP format;
	        if (/(^(CP)[0-9]{9})(GB)/ig.test(trackingNumber)) {
	
	          return errorMap.INVALID_CP;
	        }
	
	        if (!/[A-Z]{2}[0-9]{9}[A-Z]{2}/ig.test(trackingNumber)) {
	
	          return 'checkPFW';
	        }
	
	        if (checkS10Calculation(trackingNumber)) {
	
	          // GB suffix and NOT the following prefixes:
	          // CK , CP, CU, EA, EB, ED, EE, EH, EK, EU, EC.
	          // NO GB suffix and NOT the following prefixes:
	          // CA-CZ, EA-EZ, BA-BZ, PA, ND-NS.
	          if (!/((CK)|(CP)|(CU)|(E[A-E])|(EH)|(EK)|(EU))[0-9]{9}GB/ig.test(trackingNumber) && !/((C[A-Z])|(E[A-Z])|(B[A-Z])|(PA)|(N[D-S]))[0-9]{9}(?!GB)[A-Z]{2}/ig.test(trackingNumber)) {
	
	            return true;
	          }
	
	          return 'checkPFW';
	        }
	
	        return errorMap.INVALID_THIRTEEN;
	      }
	
	      // This is always a Parcelforce number.
	      if (trackingNumberLength === 14) {
	
	        return 'checkPFW';
	      }
	
	      return false;
	    },
	
	    errorMessageMap: function errorMessageMap(validationResult) {
	
	      var errResult = void 0;
	
	      switch (validationResult) {
	
	        case 'INVALID_EMPTY':
	
	          errResult = configService.messages.validation.required;
	          break;
	
	        case 'INVALID_MIN_LENGTH':
	
	          errResult = configService.messages.validation.minlength;
	          break;
	
	        case 'INVALID_MAX_LENGTH':
	
	          errResult = configService.messages.validation.maxlength;
	          break;
	
	        case 'INVALID_CP':
	
	          errResult = configService.messages.validation.cp;
	          break;
	
	        case 'TIME_OUT':
	
	          errResult = configService.messages.system_error.tracking_unavailable;
	          break;
	
	        default:
	
	          errResult = configService.messages.validation.invalid_entry;
	
	          break;
	
	      }
	
	      return errResult;
	    },
	
	    splitNumber: function splitNumber(trackingNumber) {
	
	      var textGroup = [];
	      var i = void 0;
	      var len = void 0;
	      var filteredtrackingNumber = '';
	
	      filteredtrackingNumber = trackingNumber.replace(/\s/g, '');
	
	      for (i = 0, len = filteredtrackingNumber.length; i < len; i += 4) {
	
	        textGroup.push(filteredtrackingNumber.substr(i, 4));
	      }
	
	      return textGroup.join(' ');
	    },
	
	    isNumber: isNumber,
	
	    isValueZero: isValueZero,
	
	    areValidCoordinates: areValidCoordinates
	
	  };
	}
	
	exports.default = numberService;

/***/ }),
/* 71 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * @description: Notification Service.
	 * @requires {Object} baseSixtyFour Polyfill to decode b64 strings.
	 */
	function notificationService(baseSixtyFour) {
	
	  return {
	
	    /**
	     * @description: Decodes a base64 MAC token into a MAC HEX String.
	     *
	     * @param MacToken {String} URL passed.
	     * @returns {String} Decoded HEX String.
	     */
	    decodeMAC: function decodeMAC(MacToken) {
	      return baseSixtyFour.urlDecodeToHex(MacToken);
	    },
	
	    /**
	     * @description: Checks if there is a valid session.
	     *
	     * @param expiary {number} the current session timestamp.
	     * @returns {boolean} true if the session is invalid.
	     */
	    isNewSessionNeeded: function isNewSessionNeeded(expiary) {
	
	      // Transform the Date().getTime() from milliseconds to seconds.
	      var now = Math.floor(new Date().getTime() / 1000);
	
	      // Threshold in seconds when the session must be renewed.
	      var threshold = 30;
	
	      return parseInt(expiary, 10) - now < threshold;
	    }
	  };
	}
	
	exports.default = notificationService;

/***/ }),
/* 72 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function parcelForceService() {
	
	  var error = void 0;
	
	  function isParcelForceCode(trackingCode) {
	
	    if (trackingCode) {
	
	      switch (trackingCode.length) {
	        // 9 Characters numbers can only be in the form XX9999999 or 999999999
	        case 9:
	
	          if (/[0-9A-Z]{2}[0-9]{7}/ig.test(trackingCode)) {
	
	            return true;
	          }
	
	          error = 'INVALID_NINE';
	          break;
	        case 12:
	          // 12 Characters 999999999999 or start with 9826 or start with 9830.
	          if (/9826[0-9]{8}/ig.test(trackingCode) || /9830[0-9]{8}/ig.test(trackingCode) || /[0-9]{12}/ig.test(trackingCode)) {
	
	            return true;
	          }
	
	          error = 'INVALID_TWELVE';
	          break;
	        case 13:
	          // Only these formats are valid:
	          // 3SXXXX9999999
	          // 3E99999999999
	          // 8E99999999999
	          if (/3S[A-Z]{4}[0-9]{7}/ig.test(trackingCode) || /3E[0-9]{11}/ig.test(trackingCode) || /8E[0-9]{11}/ig.test(trackingCode)) {
	
	            return true;
	          }
	
	          // Only these formats are valid:
	          // 99999999999XX
	          // XXXX9999999GB
	          // 9XXXX99999999
	          if (/[0-9]{11}[A-Z]{2}/ig.test(trackingCode) || /[A-Z]{4}[0-9]{7}GB/ig.test(trackingCode) || /[0-9]{1}[A-Z]{4}[0-9]{8}/ig.test(trackingCode)) {
	
	            return true;
	          }
	
	          // NO GB suffix and the following prefixes:
	          // CA-CZ, EA-EZ, BA-BZ, PA, ND-NS
	          if (/((C[A-Z])|(E[A-Z])|(B[A-Z])|(PA)|(N[D-S]))[0-9]{9}(?!GB)[A-Z]{2}/ig.test(trackingCode)) {
	
	            return 'isPFW';
	          }
	
	          // GB suffix and the following prefixes:
	          // CK, CP, CU, EA, EB, EC, ED, EE, EH, EK, EU
	          if (/((CK)|(CP)|(CU)|(E[A-E])|(EH)|(EK)|(EU))[0-9]{9}GB/ig.test(trackingCode)) {
	
	            return 'isPFW';
	          }
	
	          error = 'INVALID_THIRTEEN_PFW';
	          break;
	        case 14:
	          // 14 Characters must be in the format XXXX9999999999 or PB999999999999
	          if (/[A-Z]{4}[0-9]{10}/ig.test(trackingCode) || /PB[0-9]{12}/ig.test(trackingCode)) {
	
	            return true;
	          }
	
	          error = 'INVALID_FOURTEEN';
	          break;
	        default:
	          return false;
	
	      }
	    }
	
	    return false;
	  }
	
	  function checkPFW(isValidNumber, trackingCode) {
	
	    error = null;
	
	    var isPFW = isParcelForceCode(trackingCode);
	
	    if (isPFW && !error) return 'isPFW';
	    if (error) return error;
	
	    return isValidNumber;
	  }
	
	  return {
	    isParcelForceCode: isParcelForceCode,
	    checkPFW: checkPFW
	  };
	}
	
	exports.default = parcelForceService;

/***/ }),
/* 73 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * @description: Google reCAPTCHA Service.
	 *
	 * @requires   {Object} applicationModel
	 * @requires   {Object} $rootScope
	 * @requires   {Object} $window
	 */
	function googleRecaptchaService(applicationModel, $rootScope, $window) {
	
	  var widgetId = null;
	  var isInitialised = false;
	
	  /**
	   * @description Check if the Google reCAPTCHA Widget is initialised or not.
	   */
	  var widgetIsInitialised = function widgetIsInitialised() {
	    return isInitialised;
	  };
	
	  /**
	   * @description Reset the reCAPTCHA widget.
	   * @returns {Boolean} True if widget was reset, false otherwise.
	   */
	  var resetCaptcha = function resetCaptcha() {
	
	    if (widgetIsInitialised()) {
	
	      $window.grecaptcha.reset(widgetId);
	      return true;
	    }
	
	    return false;
	  };
	
	  /**
	   * @description Callback triggered when the reCAPTCHA challenge has passed.
	   * We emit the event googleRecaptchaTokenAvailable with the Google reCAPTCHA
	   * Token as a parameter to allow other components to catch the event via:
	   * $rootScope.$on('googleRecaptchaTokenAvailable', token);
	   * @param {String} token A google Recaptcha token generated.
	   */
	  var captchaCallback = function captchaCallback(token) {
	
	    resetCaptcha();
	    $rootScope.$emit('googleRecaptchaTokenAvailable', token);
	  };
	
	  /**
	   * @description Renders the container as a reCAPTCHA widget and returns the ID of the newly created widget.
	   * @param {String} container The HTML element to render the reCAPTCHA widget.
	   * Specify either the ID of the container (string) or the DOM element itself.
	   * @param {String} sitekey A google reCAPTCHA sitekey to use.
	   * @returns {Number} The reCAPTCHA widget id (from 0 to n) or false if there was an issue.
	   * @throws Error if unable to initialise the reCAPTCHA widget.
	   */
	  var initialiseCaptcha = function initialiseCaptcha(container, sitekey) {
	
	    try {
	
	      widgetId = $window.grecaptcha.render(container, {
	        sitekey: sitekey,
	        callback: captchaCallback
	      }, true);
	
	      if (widgetId >= 0) {
	
	        isInitialised = true;
	
	        // Emit when widget is ready and is URL Request.
	        if (applicationModel.stopUrlRequest === false) {
	
	          applicationModel.stopUrlRequest = true;
	
	          $rootScope.$emit('googleRecaptchaWidgetAvailable');
	        }
	
	        return widgetId;
	      }
	    } catch (err) {
	
	      throw err;
	    }
	
	    return false;
	  };
	
	  /**
	   * @description Programatically invoke the reCAPTCHA check.
	   * @returns {Boolean} True if widget was invoked, false instead.
	   */
	  var invokeCaptcha = function invokeCaptcha() {
	
	    if (widgetIsInitialised()) {
	
	      $window.grecaptcha.execute(widgetId);
	      return true;
	    }
	
	    return false;
	  };
	
	  return {
	    widgetIsInitialised: widgetIsInitialised,
	    resetCaptcha: resetCaptcha,
	    captchaCallback: captchaCallback,
	    initialiseCaptcha: initialiseCaptcha,
	    invokeCaptcha: invokeCaptcha
	  };
	}
	
	exports.default = googleRecaptchaService;

/***/ }),
/* 74 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * @description: Tracking Code Service.
	 * @requires {Object} applicationModel
	 * @requires {Object} parcelsService
	 * @requires {Object} configService
	 */
	function trackingCodeService(applicationModel, parcelsService, configService) {
	
	  /**
	   * @description Check if a Google reCAPTCHA check needs to be triggered.
	   * @returns {Boolean} True if we need to trigger a reCAPTCHA check, false instead.
	   */
	  var triggerGoogleRecaptchaCheck = function triggerGoogleRecaptchaCheck() {
	
	    var googleRecaptchaCheckRequired = configService.google_recaptcha.enabled;
	    var decodedSessionToken = void 0;
	
	    // If there is a reCAPTCHA session token available, check if it is still
	    // available, if yes no need to trigger a reCAPTCHA check.
	    if (applicationModel.googleRecaptcha.sessionToken) {
	
	      // Transform the Date().getTime() from milliseconds to seconds.
	      var now = Math.floor(new Date().getTime() / 1000);
	
	      decodedSessionToken = parcelsService.decodeJWT(applicationModel.googleRecaptcha.sessionToken);
	
	      if (parcelsService.isSet(decodedSessionToken, 'exp') && parseInt(decodedSessionToken.exp, 10) && decodedSessionToken.exp > now) {
	
	        googleRecaptchaCheckRequired = false;
	      } else {
	
	        // There is a google reCAPTCHA session token available but it has
	        // expired, reset it in the model.
	        applicationModel.googleRecaptcha.sessionToken = null;
	      }
	    }
	
	    return googleRecaptchaCheckRequired;
	  };
	
	  return {
	    triggerGoogleRecaptchaCheck: triggerGoogleRecaptchaCheck
	  };
	}
	
	exports.default = trackingCodeService;

/***/ }),
/* 75 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Handles Event Type related functions.
	**/
	function eventTypeService(configService) {
	
	  /**
	   * Gets the Event type.
	   * @param {Array} events
	   * @param {Array} outdoorEvents
	   * @param {Array} indoorEvents
	   * @returns {String} eventType
	   */
	  function getEventType(events, outdoorEvents, indoorEvents) {
	
	    for (var i = 0; i < events.length; i++) {
	
	      var eventCode = events[i].eventCode;
	      // checks for eventCode availability in outdoor type events category.
	      if (outdoorEvents.indexOf(eventCode) !== -1) {
	
	        return 'outdoor';
	      }
	      // checks for eventCode availability in indoor type events category.
	      if (indoorEvents.indexOf(eventCode) !== -1) {
	
	        return 'indoor';
	      }
	    }
	    return '';
	  }
	
	  /**
	   * Gets the event type text.
	   * @param {Array} events
	   * @returns {String} eventType corresponding text.
	   */
	  function getEventTypeText(events) {
	
	    var eventType = getEventType(events, configService.outdoor_events, configService.indoor_events);
	    if (!eventType) {
	
	      return configService.messages.gps.not_recognized_event_type;
	    }
	    return configService.messages.gps[eventType + '_text'];
	  }
	
	  return {
	    getEventType: getEventType,
	    getEventTypeText: getEventTypeText
	  };
	}
	
	exports.default = eventTypeService;

/***/ }),
/* 76 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * @description : Format a date into print ready.
	 * @param {Object} configService The configuration Service object.
	 * @returns {String} The formatted time string.
	 */
	function timeFilter(configService) {
	
	  return function (time) {
	
	    var timeSplit = time.split(':');
	    var suffix = timeSplit[0] < 12 ? configService.messages.summary_line_edw.am : configService.messages.summary_line_edw.pm;
	    timeSplit[0] = timeSplit[0] % 12 || 12;
	    return parseInt(timeSplit[0], 10) + ':' + timeSplit[1] + suffix;
	  };
	}
	
	exports.default = timeFilter;

/***/ }),
/* 77 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * @description : Replace all non alpha-numeric chars by - and apply
	 * lowerCase().
	 * @param {String} statusCategoryToFormat A statusCategory to format.
	 * @returns {String} The formatted dynamic string.
	 */
	function statusCategoryFilter(configService) {
	
	  return function (statusCategoryToFormat) {
	
	    var statusCatIconsObj = configService.api.status_cat_value_mapping;
	    var classNamePart = configService.api.status_cat_class_part;
	    var catArray = [];
	    var iconIndex = 0;
	
	    angular.forEach(statusCatIconsObj, function (value, key) {
	
	      catArray.push(statusCatIconsObj[key]);
	    });
	
	    // We are handling the Error Items Category on the recently-tracked.view.html, not coming from the API.
	    iconIndex = catArray.indexOf(statusCategoryToFormat);
	
	    return iconIndex !== -1 ? "" + classNamePart + iconIndex : "" + classNamePart + statusCatIconsObj.no_status;
	  };
	}
	
	exports.default = statusCategoryFilter;

/***/ }),
/* 78 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * @description : Format by 4 Characters and then space.
	 * @param {String} trackingNumber - trackingNumber to format.
	 * @returns {String} The formatted dynamic string.
	 */
	function splitNumberFilter() {
	
	  return function (trackingNumber) {
	
	    var textGroup = [];
	    var i = void 0;
	    var len = void 0;
	    var filteredtrackingNumber = '';
	
	    filteredtrackingNumber = trackingNumber.replace(/\s/g, '');
	
	    for (i = 0, len = filteredtrackingNumber.length; i < len; i += 4) {
	
	      textGroup.push(filteredtrackingNumber.substr(i, 4));
	    }
	
	    return textGroup.join(' ');
	  };
	}
	
	exports.default = splitNumberFilter;

/***/ }),
/* 79 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function arrayToParagraph() {
	
	  return function (addressObj) {
	
	    var address = [];
	
	    Object.keys(addressObj).forEach(function (line) {
	
	      if (addressObj[line]) {
	
	        address.push(addressObj[line]);
	      }
	    });
	
	    return address.join('<br />');
	  };
	}
	
	exports.default = arrayToParagraph;

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _parcelsConfigEn = __webpack_require__(81);
	
	var _parcelsConfigEn2 = _interopRequireDefault(_parcelsConfigEn);
	
	var _parcelsConfigCy = __webpack_require__(82);
	
	var _parcelsConfigCy2 = _interopRequireDefault(_parcelsConfigCy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function bootstrap() {
	
	  angular.element(document).ready(function () {
	
	    var initInjector = angular.injector(['ng']);
	    var $http = initInjector.get('$http');
	    var lang = document.documentElement.lang;
	    var localConfig = lang === 'en' ? _parcelsConfigEn2.default : _parcelsConfigCy2.default;
	    var remoteConfigFile = 'parcels-config.json';
	
	    if (document.getElementById('appConfig')) {
	
	      remoteConfigFile = document.getElementById('appConfig').href;
	    }
	
	    $http.get(remoteConfigFile).success(function (remoteConfig) {
	
	      angular.module('app').config(["configServiceProvider", function (configServiceProvider) {
	
	        configServiceProvider.config(localConfig);
	        configServiceProvider.config(remoteConfig);
	      }]);
	
	      angular.bootstrap(document, ['app']);
	    });
	  });
	}
	
	exports.default = bootstrap;

/***/ }),
/* 81 */
/***/ (function(module, exports) {

	module.exports = {"messages":{"validation":{"required":"Please enter a reference number.","minlength":"Sorry - we don't recognise that number. Please check the information below to make sure your tracking code is correct.","maxlength":"Sorry - we don't recognise that number. Please check the information below to make sure your tracking code is correct.","cp":"Online tracking is not available for this Parcelforce service. The delivery speed is not guaranteed, so please check our country information pages and then confirm delivery with your recipient.","invalid_entry":"Sorry - we don't recognise that number. Please check the information below to make sure your tracking code is correct."},"tracking_code":{"tracking_placeholder":"eg. XH 5455 5453 3GB","header":"Tell us your reference number…","description":"This is a long line of numbers and letters, which you’ll find on your postage receipt or in the sender’s delivery message.","button_label":"Track your delivery","overlay_link_url":"https://personal.help.royalmail.com/app/answers/detail/a_id/66","overlay_link_text":"Need help with your reference number?"},"reference_help":{"header":"Need help with your reference number?","or":"OR","body":"You'll find your item's reference number on your postage receipt or on your email from us. To keep items safe, we won't resend reference numbers. <br><br> There are several types of reference numbers, ranging from 9 to 27 characters long and often ending in 'GB'. Not all items will have a reference number though. For more information, see: <a href='http://www.royalmail.com/personal/sending-mail'>I'm using Track and Trace, how do I find my reference number?</a> <br><br> If you're the recipient and you haven't had a message from us, ask the sender if they have a tracking reference number for your delivery.","footer_header":"Didn't find what you were looking for?","footer_line_one":"Browse our <a>help section</a> or <a>contact us</a>.","footer_line_one_mob":"Browse our help section or contact us."},"button":{"close":"Close"},"pfw":{"overlay_heading":"Parcelforce delivery","overlay_text":"The reference number you’ve entered is for a Parcelforce delivery. To get tracking information for this item, please go to","overlay_website":"Parcelforce.com","limited_history":"Please note, this item is shipped by Parcelforce.<br/>More tracking information can be found by using this reference number","limited_history_text":"ParcelForce website."},"summary_line_edw":{"initial_text":"We normally expect to deliver your items to your address between","no_start_text":"We normally expect to deliver items to your address by","am":"am","pm":"pm","no_start_end_text":"We expect to deliver your item today","future_start_end_text":"We expect to deliver it on","between":"between","by":"by","date_format":"dd/MM/yyyy"},"parcelflown":{"header":"Handed to:","button":"Continue tracking"},"pod_print":{"header":"Track your Item","sub_header":"Proof of Delivery","product_name":"Service used:","parcel_delivery_message":"Your Parcel was successfully delivered to your delivery address.","signed_for":"Signed for by:","delivery":"Delivered:","button":"Print","rotate_button":"Rotate image","royal_mail_logo":"http://www.royalmail.com/sites/all/themes/royalmail2017/img/royalmail-logo.png","logo_alt_text":"Royal Mail"},"tracking_results":{"tracking_code_text":"Tracking no.","history_label":"Updated on:","maximize":"See your item's full journey","minimize":"Hide earlier journey","going_to":"To:","sent_from":"From:","months":"January, February, March, April, May, June, July, August, September, October, November, December","days":"Sunday, Monday, Tuesday, Wednesday, Thursday, Friday, Saturday","service_used":"Service used:","pod_image_error":"The image is not available or has been removed."},"redelivery":{"link_text":"Choose what you want to do with your item","link":"personal/receiving-mail/redelivery","help_link_one":"Which ID should I bring?","help_link_two":"Can another person collect this for me?","button_redelivery_options":"Redelivery Options","button_inflight_options":"Not going to be in?","inflight_url":"change-delivery-option","query_param":"trackingNumber"},"recently_tracked":{"limit_information":"You have reached the 30 item storage limit, new searched items will remove the oldest from your count.","shown_amount_before_no":"Showing","shown_amount_after_no":"most recently searched items of those saved.","details_button":"Details","refresh_button":"Refresh","save_item_button":"Save this item","redelivery_button":"Redelivery Options","save_items":"There are currently no items in your list.","login":"<p> Log in or register to save your tracking number and easily check the progress of your item. </p> <p> Please note if you have previously saved 30 items then this item will remove the oldest in your history.</p>'","login_default":"Have an account? Log in to see the deliveries you’ve been tracking recently. </br> <a href='user/login'>Log in</a>","error":"We could not retrieve your details. Please try again later.","full_page_link_text":"View all recently tracked deliveries"},"system_error":{"tracking_unavailable":"The tracking system is currently unavailable. Please try again later."},"card_error_title":"Tracking error","tracking_another":{"track_another":"Track another number"},"gps":{"show_on_map_link_text":"Show on map","close_map_link_text":"Close map","coordinates":"GPS coordinates:","map_error":"Sorry, we have a problem. Please try again later","indoor_text":"A Local Collect delivery was chosen for this item, so the location will be a Post Office® or Royal Mail Delivery Office.","outdoor_text":"This is the scanned location of your delivery. This includes deliveries to a neighbour, Safeplace, or Royal Mail Delivery Office.","not_recognized_event_type":"This is the scanned location of your delivery. This includes deliveries to a neighbour, Safeplace, Post Office® or Royal Mail Delivery Office."}},"api":{"app_id":"5d3c8a1a-c158-4194-977e-a10143a90ce3","base":"https://localhost:8009","ibm_client_id":"5d3c8a1a-c158-4194-977e-a10143a90ce3","script_timeout":30000,"recently_tracked_max_items":4,"status_cat_class_part":"icon_status_","status_cat_value_mapping":{"no_status":"no-status","were_expecting_it":"We're expecting it","weve_got_it":"We've got it","left_origin_country":"Left Origin Country","in customs":"In Customs","released_from_customs":"Released from Customs","left_the_uk":"Left the UK","in_transit":"In Transit","ready_for_delivery":"Ready for Delivery","delivery_attempted":"Delivery Attempted","pending":"Pending","returned_to_sender":"Returned to Sender","delivered":"Delivered","collected":"Collected","duplicate_identified":"Duplicate Identified","restricted_or_prohibited_contents":"Restricted or Prohibited Contents"}},"google_recaptcha":{"enabled":false,"site_key":"6LckfyMUAAAAAB0WtmGh0vZ0EFoG-K_240Xcfvdq","container":"recaptcha","widget_size":"invisible"},"bingMapConfig":{"key":"Au90_vauPZSR_KOGvU4oreYe0YzH-pT5rbFGftyWY2fKY9uRuB-1A5mq8UVkEuBj","url":"https://www.bing.com/api/maps/mapcontrol","minZoom":18},"indoor_events":["EVNLC","EVKLC","EVKLS"],"outdoor_events":["EVKSP","EVKOP","EVKSF","EVKDN","EVKNS","EVVDD","EVVDN","EVYDD","EVYDN"],"links":{"limited_history_pfw":"https://www.parcelforce.com/track-trace?trackNumber=","rti_full_page":"/track-your-item/rti"},"misc":{"inline_track_another_enabled":false,"tracking_results_inflight_enabled":false,"tracking_results_gps_enabled":false},"tealium":{"site_prefix":"RM Web App","instance":"Personal","app_name":"Track and Trace"},"chatbot":{"chatbotFrequency":".25","flmntApiKey":"8dc32c28696b427daa5ce6759234f4d4","flmntWidgetTitle":"Track & Trace","flmntWidgetPlaceholder":"Message","flmntWidgetError":"Sorry","flmntWidgetUrl":"https://rmgchat.filamentengine.com/"},"breadcrumbs":"[\"Home\",\"Track and Trace - Track your Item\"]"}

/***/ }),
/* 82 */
/***/ (function(module, exports) {

	module.exports = {"messages":{"validation":{"required":"Please enter a reference number.","minlength":"Sorry - we don't recognise that number. Please check the information below to make sure your tracking code is correct.","maxlength":"Sorry - we don't recognise that number. Please check the information below to make sure your tracking code is correct.","cp":"Online tracking is not available for this Parcelforce service. The delivery speed is not guaranteed, so please check our country information pages and then confirm delivery with your recipient.","invalid_entry":"Sorry - we don't recognise that number. Please check the information below to make sure your tracking code is correct."},"tracking_code":{"tracking_placeholder":"eg. XH 5455 5453 3GB","header":"Tell us your reference number…","description":"This is a long line of numbers and letters, which you’ll find on your postage receipt or in the sender’s delivery message.","button_label":"Track your delivery","overlay_link_url":"https://personal.help.royalmail.com/app/answers/detail/a_id/66","overlay_link_text":"Need help with your reference number?"},"reference_help":{"header":"Need help with your reference number?","or":"OR","body":"You'll find your item's reference number on your postage receipt or on your email from us. To keep items safe, we won't resend reference numbers. <br><br> There are several types of reference numbers, ranging from 9 to 27 characters long and often ending in 'GB'. Not all items will have a reference number though. For more information, see: <a href='http://www.royalmail.com/personal/sending-mail'>I'm using Track and Trace, how do I find my reference number?</a> <br><br> If you're the recipient and you haven't had a message from us, ask the sender if they have a tracking reference number for your delivery.","footer_header":"Didn't find what you were looking for?","footer_line_one":"Browse our <a>help section</a> or <a>contact us</a>.","footer_line_one_mob":"Browse our help section or contact us."},"button":{"close":"Close"},"pfw":{"overlay_heading":"Parcelforce delivery","overlay_text":"The reference number you’ve entered is for a Parcelforce delivery. To get tracking information for this item, please go to","overlay_website":"Parcelforce.com","limited_history":"Please note, this item is shipped by Parcelforce.<br/>More tracking information can be found by using this reference number","limited_history_text":"ParcelForce website."},"summary_line_edw":{"initial_text":"Rydym fel arfer yn disgwyl dosbarthu eich eitemau i'ch cyfeiriad rhwng","no_start_text":"Rydym fel arfer yn disgwyl dosbarthu eitemau i'ch cyfeiriad erbyn","am":"am","pm":"pm","no_start_end_text":"Disgwyliwn gyflwyno'ch eitem heddiw","future_start_end_text":"Rydym yn disgwyl ei gyflawni ymlaen","between":"rhwng","by":"gan","date_format":"dd/MM/yyyy"},"parcelflown":{"header":"Rhoddwyd i:","button":"Parhau i olrhain"},"pod_print":{"header":"Olrhain eich Eitem","sub_header":"Prawf Dosbarthu","product_name":"Gwasanaeth a ddefnyddiwyd:","parcel_delivery_message":"Cafodd eich Parsel ei ddosbarthu'n llwyddiannus i'ch cyfeiriad dosbarthu.","signed_for":"Llofnodwyd gan:","delivery":"Dosbarthwyd:","button":"Argraffu","rotate_button":"Cylchdroi delwedd","royal_mail_logo":"http://www.royalmail.com/sites/all/themes/royalmail2017/img/royalmail-logo.png","logo_alt_text":"Royal Mail"},"tracking_results":{"tracking_code_text":"Rhif olrhain","history_label":"Diweddarwyd ar:","maximize":"Gweler taith lawn eich eitemy","minimize":"Cuddiwch taith gynharach","going_to":"At:","sent_from":"O:","months":"Ionawr, Chwefror, Mawrth, Ebrill, Mai, Mehefin, Gorffennaf, Awst, Medi, Hydref, Tachwedd, Rhagfyr","days":"Dydd Sul, Dydd Llun, Dydd Mawrth, Dydd Mercher, Dydd Iau, Dydd Gwener, Dydd Sadwrn","service_used":"Gwasanaeth a ddefnyddiwyd:","pod_image_error":"Nid yw'r ddelwedd ar gael neu mae wedi ei dileu."},"redelivery":{"link":"personal/receiving-mail/redelivery","link_text":"Choose what you want to do with your item","help_link_one":"Which ID should I bring?","help_link_two":"Can another person collect this for me?","button_redelivery_options":"Redelivery Options","button_inflight_options":"Ddim yn mynd i fod i mewn?","inflight_url":"change-delivery-option","query_param":"trackingNumber"},"recently_tracked":{"limit_information":"You have reached the 30 item storage limit, new searched items will remove the oldest from your count.","shown_amount_before_no":"Showing","shown_amount_after_no":"most recently searched items of those saved.","details_button":"Details","refresh_button":"Refresh","save_item_button":"Save this item","redelivery_button":"Redelivery Options","save_items":"There are currently no items in your list.","login":"<p> Log in or register to save your tracking number and easily check the progress of your item. </p> <p> Please note if you have previously saved 30 items then this item will remove the oldest in your history.</p>'","login_default":"Have an account? Log in to see the deliveries you’ve been tracking recently. </br> <a href='user/login'>Log in</a>","error":"We could not retrieve your details. Please try again later.","full_page_link_text":"View all recently tracked deliveries"},"system_error":{"tracking_unavailable":"The tracking system is currently unavailable. Please try again later."},"card_error_title":"Tracking error","tracking_another":{"track_another":"Track another number"},"gps":{"show_on_map_link_text":"Dangos ar y map","close_map_link_text":"Cau'r map","coordinates":"Cyfesurynnau GPS:","map_error":"Mae'n ddrwg gennym, mae gennym broblem. Rhowch gynnig arall arni yn nes ymlaen","indoor_text":"Dewiswyd danfoniad Local Collect ar gyfer yr eitem hon, felly'r lleoliad fydd Swyddfa Bost® neu Swyddfa Ddanfon y Post Brenhinol.","outdoor_text":"Dyma'r lleoliad a sganiwyd ar gyfer eich danfoniad. Mae hyn yn cynnwys danfoniadau i gymydog, Safeplace, neu Swyddfa Ddanfon y Post Brenhinol.","not_recognized_event_type":"Dyma'r lleoliad a sganiwyd ar gyfer eich danfoniad. Mae hyn yn cynnwys danfoniadau i gymydog, Safeplace, Swyddfa'r Post® neu Swyddfa Ddanfon y Post Brenhinol."}},"api":{"app_id":"5d3c8a1a-c158-4194-977e-a10143a90ce3","base":"https://localhost:8009","ibm_client_id":"5d3c8a1a-c158-4194-977e-a10143a90ce3","script_timeout":30000,"recently_tracked_max_items":4,"status_cat_class_part":"icon_status_","status_cat_value_mapping":{"no_status":"no-status","were_expecting_it":"We're expecting it","weve_got_it":"We've got it","left_origin_country":"Left Origin Country","in customs":"In Customs","released_from_customs":"Released from Customs","left_the_uk":"Left the UK","in_transit":"In Transit","ready_for_delivery":"Ready for Delivery","delivery_attempted":"Delivery Attempted","pending":"Pending","returned_to_sender":"Returned to Sender","delivered":"Delivered","collected":"Collected","duplicate_identified":"Duplicate Identified","restricted_or_prohibited_contents":"Restricted or Prohibited Contents"}},"google_recaptcha":{"enabled":false,"site_key":"6LckfyMUAAAAAB0WtmGh0vZ0EFoG-K_240Xcfvdq","container":"recaptcha","widget_size":"invisible"},"bingMapConfig":{"key":"Au90_vauPZSR_KOGvU4oreYe0YzH-pT5rbFGftyWY2fKY9uRuB-1A5mq8UVkEuBj","url":"https://www.bing.com/api/maps/mapcontrol","minZoom":18},"indoor_events":["EVNLC","EVKLC","EVKLS"],"outdoor_events":["EVKSP","EVKOP","EVKSF","EVKDN","EVKNS","EVVDD","EVVDN","EVYDD","EVYDN"],"links":{"limited_history_pfw":"https://www.parcelforce.com/track-trace?trackNumber=","rti_full_page":"/cy/track-your-item/rti"},"misc":{"inline_track_another_enabled":false,"tracking_results_inflight_enabled":false,"tracking_results_gps_enabled":false},"tealium":{"site_prefix":"RM Web App","instance":"Personal","app_name":"Track and Trace"},"chatbot":{"chatbotFrequency":".25","flmntApiKey":"8dc32c28696b427daa5ce6759234f4d4","flmntWidgetTitle":"Track & Trace","flmntWidgetPlaceholder":"Message","flmntWidgetError":"Sorry","flmntWidgetUrl":"https://rmgchat.filamentengine.com/"},"breadcrumbs":"[\"Home\",\"Gallwch olrhain a diwygio eich eitemau dosbarthu\"]"}

/***/ }),
/* 83 */
27
]);


// WEBPACK FOOTER //
// app.bundle.js